export default {
  'zh-CN': {
    message: {
      hello: '你好',
    },
    demo: {
      info1: '您当前阅览的是DEMO数据，想获得自己产品的数据？',
      info2: '您当前阅览的是DEMO数据，立即阅读自己的数据？',
      link: '立即阅读您的数据',
      login: '立即注册，登录',
    },
    guide: {
      start: '选择一款应用，开启全新的数据之旅！',
      iknow: '我知道了',
      next: '下一步',
      skip: '跳过',
      quality: '通过姿态检测等黑科技，准确识别异常设备',
      portrait: '通过性别，年龄，应用偏好，进一步了解用户',
      exploration: '版本分布、地域分布汇总在这里啦',
      analysis: '这里汇总了分析相关的功能',
      push: '推送营销功能搬到这里啦',
      helper: '错误报告、易认证汇总在这里',
      manage: '应用设置、事件管理等功能汇总在这里',
      auth: '点这里，邀请小伙伴一起关注应用表现吧',
    },
    onlineService: {
      online: '在线',
      service: '客服',
    },
    common: {
      loading: '加载中...',
      nodata: '未查询到数据',
      errorTip: '获取数据失败，请重试',
      delFailed: '删除失败，请重试',
      updateFailed: '更新失败，请重试',
      fail: '操作失败！',
      input: '请输入',
      hide: '隐藏',
      show: '显示',
      copy: '复制',
      suc: '成功',
      send: '发送',
      contain: '包含',
      nocontain: '不包含',
      yes: '是',
      no: '否',
      certain: '确定',
      cancel: '取消',
      save: '保存',
      search: '搜索',
      noSave: '设置内容尚未保存！',
      isLeave: '如果现在离开，系统将放弃所做的配置或修改，是否确认离开当前页面？',
      channelNameLength: '渠道名称为0-16位中文、字母、数字、下划线、中划线，请重新输入',
    },
    filter: {
      week: '最近一周',
      month: '最近一个月',
      threeMonth: '最近三个月',
      halfYear: '最近半年',
      oneYear: '最近一年',
      conditions: '筛选',
      choose: '选择',
      partner: '渠道',
      usergroup: '用户分群',
      version: '版本',
      clear: '清空',
      confirm: '确认',
      cancel: '取消',
      search: '搜索',
      all: '全选',
      err: '至少需选择一种平台！',
      supportUserGroup: '系统暂不支持所选指标或指标组合进行分群分析',
    },
    header: {
      analytics: '应用分析',
      push: '推送营销',
      market: '市场洞察',
      helper: '开发助手',
      manage: '应用管理',
      lang: 'English',
      setting: '设置',
      signout: '退出登录',
      center: '账户中心',
      back: '返回旧版本',
      accountTitle: '邀请工作伙伴共同查阅数据',
      notice: '系统通知',
      grant: '账户授权',
      code: {
        app: 'TalkingData客户端',
        down: '扫码下载',
        service: '微信企业服务号',
        focus: '扫码关注',
      },
    },
    appInfo: {
      title: '系统公告',
      usergroupModal: {
        a: '系统暂不支持对该功能进行分群分析，如果需要分析，请到数据探索功能选择相关指标',
        b: '系统暂不支持对所选指标进行分群分析',
      },
    },
    overview: {
      title: '应用概览',
      cumulative: '累计设备',
      suspicious: '可疑设备',
      week: '近7日活跃设备',
      month: '近30日活跃设备',
      single: '近7日单设备日均使用时长',
      explain: {
        a: '从集成TalkingDataApp Analytics SDK开始，截止某日统计到的设备总量',
        b: '最近30日新增的设备中，由于使用行为异常被标识为可疑设备数',
        c: '最近7日（不含查询当日）最少使用过一次应用的设备数',
        d: '最近30日（不含查询当日）最少使用过一次应用的设备数',
        e: '一台设备平均每日使用应用的时间。',
      },
    },
    nav: {
      overview: {
        title: '数据概览',
        app: '应用概览',
        data: '实时数据',
        trend: '用户趋势',
        channel: '渠道分析',
        uninstall: '卸载分析',
        keep: '留存分析',
        scene: '场景分析',
        share: '分享及传播',
        scan: '扫码分析',
        quality: '用户质量评估',
      },
      table: {
        title: '我的报表',
        custom: '定制报表名称',
        create: '新建自定义报表',
      },
      user: {
        title: '用户探索',
        feature: '用户特征',
        portrait: '用户画像',
        group: '用户分群',
        detail: '用户详情',
        mcDrainage: '智能营销云',
      },
      behavior: {
        title: '用户行为分析',
        page: '页面访问',
        event: '事件分析',
        funnel: '转化漏斗',
        flexible: '灵动分析',
      },
      exploration: {
        title: '数据探索',
        eventTitle: '事件探索',
      },
      business: {
        title: '电商业务分析',
        transaction: '交易分析',
        purchase: '复购分析',
      },
      account: {
        title: '账户与授权',
      },
      push: {
        push: '推送营销',
        options: '推送配置',
      },
      err: {
        report: '错误报告',
        analytics: '错误分析',
        list: '错误列表',
        detail: '错误详情',
      },
      exportLog: '日志导出',
      exportData: '日志导出',
      eauth: {
        eauth: '易认证',
        overview: '认证概览',
        list: '认证详情',
        message: '短信设置',
        warning: '预警通知',
      },
      manage: {
        title: '应用管理',
        info: '基本信息',
        channel: '渠道管理',
        event: '事件管理',
        warn: '预警通知',
        edition: '版本管理',
        data: '数据接口',
        note: '报表备注',
        qrcode: '二维码管理',
        subscription: '订阅服务',
        subscriptionEdit: '订阅服务-编辑或新增',
      },
    },
    productCenter: {
      title: '产品中心',
      title1: '管理中心',
      create: '创建应用',
      productname: '应用名称',
      platform: '应用平台',
      miniAppID: '小程序ID',
      miniAppSecret: '小程序密钥',
      totaluser: '累积覆盖设备',
      today_new: '今日新增设备',
      yes_new: '昨日新增设备',
      today_active: '今日活跃设备',
      yes_active: '昨日活跃设备',
      operation: '操作',
      hoverInfo1: '您是这款应用的创建者',
      hoverInfo2: '您被授权，可查看该产品数据',
      type: '应用类型',
      game: '游戏类型',
      icon: '应用图标',
      input: '请输入',
      choose: '请选择',
      upload: '上传应用图标',
      integration: '集成统计分析SDK',
      download: '下载SDK',
      delInfo: {
        a: '删除后，应用及其数据均被删除，无法恢复。',
        b: '是否确定删除此应用？',
        cancel: '取消',
        confirm: '确定',
      },
      delSuc: '删除产品成功',
      email: '受邀者邮箱',
      finish: '完成',
      doc: {
        a: {
          title: '选项说明',
          content: [
            '跨平台应用只需建立一次。各平台中使用同一App ID，同时支持查看单一平台和聚合全平台数据。',
            '认真选择应用类型，有利于后续查看数据报表时系统自动提供的同类型应用行业基准值的准确性。',
            '上传应用iCon，便于在数据阅览者快速匹配应用。',
          ],
        },
        b: {
          title: '邀请团队成员协助完成SDK集成',
          content: '您可以邮件通知其他团队成员辅助完成TalkingData SDK的集成和调试工作。受邀者仅可以获得SDK集成和集成调试相关工作的必备信息，如App ID，无法查阅正式发布后的数据报表，保证数据安全。'
        },
        c: {
          title: '快速集成指南',
        },
      },
      errInfo: {
        a: '应用名称不能为空',
        b: '应用名称为不超过50个字符的中文、字母、数字、下划线、中划线，请重新输入',
        c: '至少选择一个平台',
        d: '请选择一个应用类型',
        e: '请选择一个游戏类型',
        f: '邮箱格式不正确',
        g: '文件格式不正确',
        h: '超出文件大小限制。',
        i: '请上传 jpg 或 png 格式的图片',
        j: '超出文件大小限制。',
        k: '产品名称重复，请重新输入产品名',
        l: '创建产品失败',
        m: '最长不超过64位',
        n: '不能为空',
      },
      miniAppError: {
        a: '小程序ID或小程序密钥错误',
        b: '系统繁忙，请稍后重试',
        c: '为不超过64字符的字母、数字，请重新输入',
      },
      getMiniAppID: '如何获取小程序ID',
      getMiniAppSecret: '如何获取小程序密钥',
      sendFinish: '邮件已发送',
    },
    productType: {
      key19: '书籍',
      key0: '游戏',
      key20: '娱乐',
      key10: '社交',
      key17: '购物与电商',
      key11: '生活',
      key16: '工具',
      key21: '效率',
      key22: '天气',
      key23: '体育',
      key24: '音乐',
      key25: '新闻',
      key26: '报刊杂志',
      key27: '参考',
      key28: '导航',
      key29: '财务金融',
      key12: '健康健美',
      key30: '教育',
      key31: '旅游与出行',
      key32: '商业',
      key9: '摄影录像',
      key33: '医疗',
      key13: '动态壁纸',
      key14: '窗口小部件',
      key8: '其他',
      key3: '角色扮演',
      key34: '模拟类',
      key4: '体育游戏',
      key7: '策略游戏',
      key2: '智力游戏',
      key6: '动作游戏',
      key35: '探险游戏',
      key1: '街机游戏',
      key5: '桌面游戏',
      key36: '扑克牌',
      key37: '娱乐场',
      key38: '股子游戏',
      key39: '教育游戏',
      key40: '家庭游戏',
      key18: '儿童游戏',
      key41: '音乐游戏',
      key42: '赛车游戏',
      key43: '小游戏',
      key44: '文字游戏'
    },
    channel: {
      overview: {
        trend: '渠道趋势',
        top5: 'TOP5渠道趋势',
        show: '渠道总览',
        details: '渠道趋势详情',
        setInfo: '进行渠道管理',
      },
      tableview: {
        name: '渠道名称',
        platform: '平台',
        set: '操作',
        number: {
          name: '数量指标',
          newusertoday: '今日新增',
          newuseryesterday: '昨日新增',
          newuser: '新增设备',
          launchuser: '活跃设备',
          launchuserAverage: '活跃设备均值',
          startup: '启动次数',
          totaluser: '累积设备',
        },
        quality: {
          name: '质量指标',
          startuptoday: '今日启动',
          launchtoday: '今日活跃',
          launchyesterday: '昨日活跃',
          launchuser: '活跃设备',
          startup: '启动次数',
          startupAverage: '人均启动次数',
          onetime: '单次使用时长',
          onceuser: '一次性用户占比',
        },
        keep: {
          name: '留存指标',
          oneday: '次日留存率',
          week: '7日留存率',
          month: '30日留存率',
        },
      },
      index: {
        a: ': 所选日期内，首次安装打开应用且安装渠道为所选渠道的设备数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量。',
        b: ': 所选日期内，所选渠道贡献的设备中（不限定新增时间），至少使用过一次应用的设备数。',
        c: ': 所选日期内，所选渠道贡献的设备中（不限定新增时间），每日至少使用过一次应用的设备数均值。',
        d: ': 所选日期内，安装所选渠道安装包的应用被启动的总次数。',
        e: ': 从集成TalkingDataApp Analytics SDK开始，安装渠道为所选渠道的设备总量。',
        f: ': 所选日期内，所选渠道贡献的设备中，单设备启动应用的次数均值。',
        g: ': 所选日期内，所选渠道贡献的设备中，只在新增当天活跃，后续再无活跃的设备数及其占比。',
        h: ': 所选日期内，所选渠道贡献的设备中，每次启动应用的时长均值。',
      },
    },
    singleChannel: {
      title: '渠道分析',
      cumulative: '累计设备',
      weekadd: '周新增增长率',
      monthadd: '月新增增长率',
      weekactive: '周活跃率',
      monthactive: '月活跃率',
      single: '单设备使用时长',
      totalNumber: '合计',
      averageNumber: '均值',
      launchuserTotal: '活跃(排重)',
      explain: {
        a: '从集成TalkingDataApp Analytics SDK开始，截止某日统计到的该渠道的设备总量',
        b: '所选渠道，以所选日期内最后一天为结束日期的一周内新增设备数，相比其上一周新增设备数的变化幅度。例如，您选择考察2015-5-11至2015-5-13期间的渠道表现，此时的周设备增长率=（2015-5-7至2015-5-13期间的该渠道的新增设备数/ 2015-4-30至2015-5-6期间的该渠道的新增设备数）-1',
        c: '所选渠道，以所选日期内最后一天为结束日期的一个月内（按30天计算）新增设备数，相比其上一个月内新增设备数的变化幅度。例如，您选择考察2015-5-11至2015-5-13期间的渠道表现，此时的月设备增长率=（2015-4-14至2015-5-13期间的该渠道的新增设备数/ 2015-3-15至2015-4-13期间的该渠道的新增设备数）-1',
        d: '所选渠道，以所选日期内最后一天为结束日期的一周内活跃设备数与截止该日累计设备的比值。例如，您选择考察2015-5-11至2015-5-13期间的渠道表现，此时的周活跃率是指2015-5-7至2015-5-13期间的该渠道的活跃设备数占截止2015-5-13该渠道累计设备的比例',
        e: '所选渠道，以所选日期内最后一天为结束日期的一个月内（按30天计算）活跃设备数与截止该日累计设备的比值。例如，您选择考察2015-5-11至2015-5-13期间的渠道表现，此时的月活跃率是指2015-4-14至2015-5-13期间的该渠道的活跃设备数占截止2015-5-13该渠道累计设备的比例',
        f: '所选日期内，所选渠道贡献的设备中，单设备使用应用的时长均值',
      },
      index: {
        a: ': 所选日期内，首次安装打开应用且安装渠道为所选渠道的设备数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量。',
        b: ': 所选日期内，所选渠道贡献的设备中（不限定新增时间），至少使用过一次应用的设备数。',
        c: ': 所选时段内，使用该渠道安装包的应用被启动的总次数。',
      },
    },
    chartview: {
      distribution: '时段分布',
      diff: '对比',
      trend: '30日趋势',
      details: '查看详情',
      detailsinfo: '跳转至数据探索页面',
      newuser: {
        name: '新增设备',
        today: '今日新增',
        yesterday: '昨日新增',
        watch: '新增Watch用户',
      },
      launchuser: {
        name: '活跃设备',
        today: '今日活跃',
        yesterday: '昨日活跃',
        watch: '活跃Watch用户',
        day: '日活跃设备',
        week: '周活跃设备',
        month: '月活跃设备',
      },
      startup: {
        name: '启动次数',
        average: '人均启动次数',
        today: '今日启动',
        yesterday: '昨日启动',
      },
      startups: {
        name: '人均启动次数',
        average: '人均启动次数',
      },
      onceuser: {
        name: '一次性用户占比',
      },
      keepuser: {
        name: '留存率',
        oneday: '次日留存率',
        week: '7日留存率',
        month: '30日留存率',
      },
      onetime: {
        name: '单设备使用时长',
        onetime: '单次使用时长',
      },
      onetimes: {
        name: '单次使用时长',
        onetimes: '单次使用时长',
      },
      usetime: {
        name: '单设备使用时长',
        onetime: '单次使用时长',
      },
      table: {
        newuser: '新增设备',
        newwatch: 'Watch新增',
        launchuser: '活跃设备',
        launchwatch: 'Watch活跃',
        startup: '启动次数',
        onetime: '单次使用时长',
        average: '人均启动次数',
        daylaunchuser: '日活跃设备',
        week: '周活跃设备',
        month: '月活跃设备',
      },
      week: {
        week: '周活跃设备',
        name: '周活跃设备',
      },
      month: {
        month: '月活跃设备',
        name: '月活跃设备',
      },
      share: '分享效果',
      channel: '渠道分布',
      yesterday: '昨日',
      yTime: '昨日此时',
      today: '今日',
      total: '合计',
      average: '日均',
      range: '时间段',
      indexTime: {
        a: ': 今昨两日，每小时首次安装并且打开应用的设备数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量。',
        b: ': 今昨两日，每小时应用被启动的总次数。',
        c: ': 今昨两日，每小时活跃的设备数。分小时统计，每小时内活跃设备排重，不同时段间不排重。',
      },
      indexTrend: {
        a: ': 最近30日，每日首次安装并且打开应用的设备数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量。',
        b: ': 最近30日，每日至少启动一次应用的设备数。',
        c: ': 最近30日，每日应用被启动的总次数。',
        d: ': 最近30日，每日单设备使用应用的时长均值。',
        e: ': 最近30日，每日新增设备的次日留存率均值。',
      },
    },
    userGroup: {
      more: '了解更多',
      mcInfo: '寻找目标客户、获取潜在客户，洞察客群特征。让TalkingData智能营销云帮助您，更精准的定位客群，更多智能算法寻找潜在客群。',
      add: '新建用户群',
      name: '用户群名称',
      type: '用户类型',
      filter: '筛选条件',
      state: '状态',
      init: '计算中...',
      stable: '已完成',
      failed: '计算失败',
      time: '更新时间',
      scale: '用户规模',
      operation: '操作',
      suc: '操作成功！',
      delete: '删除',
      detail: '查阅数据',
      range: '时间范围',
      new: '新增',
      active: '活跃',
      user: '用户',
      is: '占累计比例',
      region: '国家及地区',
      china: '中国大陆及港澳台',
      event: '自定义事件',
      do: '期间，用户触发了自定义事件',
      model: '设备机型',
      os: '操作系统',
      carrier: '运营商',
      jailbreak: '是否越狱',
      crack: '破解应用',
      addevent: '添加自定义事件',
      nolimit: '不限',
      break1: '已越狱',
      break2: '未越狱',
      crack1: '已安装',
      crack2: '未安装',
      all: '全部',
      choose: '选择',
      selected: '已选',
      des: '说明：系统会自动为当前所选平台各创建一个用户群',
      des1: '满足条件的',
      des2: '设备共',
      userExpression: {
        nodata: '没有筛选条件',
        userType: '用户范围',
        userAttribute: '用户属性',
        userBehavior: '用户行为',
        newuser: '新增用户',
        launchuser: '活跃用户',
        userAttributeItem: {
          user_region: '国家及地区',
          mobile_info: '设备机型',
          os_info: '操作系统',
          isp_info: '运营商',
          partner_info: '初始渠道',
        },
      },
      errInfo: {
        a: '用户分群名称不能为空',
        b: '用户分群名称不能超过64个字符',
      },
      delInfo: {
        a: '删除后，将无法从筛选功能中直接选择这个用户分群。如需重新分析这个用户群的特征，请重新创建相应的用户群。',
        b: '是否确定删除这些用户分群？',
      },
    },
    keepuser: {
      keep: '留存率',
      newuserkeep: '新增设备留存',
      activekeep: '活跃设备留存',
      day: '日',
      week: '周',
      month: '月',
      date: '日期',
      user: '用户数',
      average: '均值',
      des: [{
        name: '新增设备留存率',
        doc: ': 所选日期内的新增设备，在之后指定时间内还在使用应用的比例。',
      }, {
        name: '活跃设备留存率',
        doc: ': 所选日期内的活跃设备，在之后指定时间内还在使用应用的比例。',
      }, {
        name: 'N日留存率',
        doc: ': 某日新增（或活跃）设备在之后第N日使用过应用的设备比例。某日新增（或活跃）后第N日使用过应用的设备/该日新增（或活跃）设备。无特殊说明时，一般均指新增设备活跃率。',
      }, {
        name: 'N周留存率',
        doc: ': 某自然周新增设备，在该周后第N个自然周使用过应用的设备比例。该周后第N个自然周使用过应用的设备/该周新增设备。',
      }, {
        name: 'N月留存率',
        doc: ': 某自然月新增设备，在该月后第N个自然月使用过应用的设备比例。该自然月后第N个自然月中使用过应用的设备/该自然月新增设备。',
      }, {
        name: '有效均值',
        doc: ': 判断+n是否是未来日期或没有完全结束的日期，是的话不参与计算。',
      }],
    },
    trend: {
      title: '数据趋势',
      table: '数据详情',
      overview: {
        title: '用户趋势',
        newuser: '新增设备',
        launchuser: '活跃设备',
        launchpro: 'DAU/MAU',
        startup: '启动次数',
        onetime: '单次使用时长',
        explain: {
          a: '所选日期内，首次安装并且打开应用的设备总数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量',
          b: '所选日期内，至少使用过一次应用的设备数',
          c: '所选日期内，当日的日活跃设备数（DAU）与30日活跃设备数（MAU）比值的均值。是社交游戏类和在线类应用常用的一项评估指标，用于分析设备粘度。比值越趋近于1表明设备活跃度越高，在比值低于0.2时，应用的传播性和互动性将会很弱。行业中也常用DAU/MAU乘以30来计算每月设备平均活跃天数',
          d: '所选日期内，应用被启动的总次数',
          e: '所选日期内，每次启动应用的时长均值',
        },
      },
      newuser: {
        name: '新增设备',
        total: '新增设备合计',
        average: '新增设备均值',
        'watch-total': '新增Watch设备合计',
        'watch-average': '新增Watch设备均值',
      },
      launchuser: {
        day: '日活跃设备',
        week: '周活跃设备',
        month: '月活跃设备',
        total: '活跃设备(排重)',
        average: '活跃设备均值',
        'watch-total': '活跃Watch设备合计',
        'watch-average': '活跃Watch设备均值',
      },
      startup: {
        name: '启动次数',
        average: '启动次数均值',
      },
      onetime: {
        name: '单次使用时长',
        average: '单次使用时长均值',
      },
      index: {
        a: ': 所选日期内，每日首次安装并且打开应用的设备数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量。',
        b: ': 当日的活跃设备数。',
        c: ': 截至当日，最近一周（含当日的7天）活跃设备数。',
        d: ': 截至当日，最近一月（含当日的30天）活跃设备数。',
        e: ': 所选日期内，每日应用被启动的总次数。',
        f: ': 所选日期内，每日每次启动应用的时长均值。',
      },
    },
    // 卸载分析
    uninstall: {
      describe: '卸载分析 ● 洞察用户净增长',
      freeOpen: '免费开通，不增加集成负担，实实在在看数据',
      needApns: '开通需要使用苹果官方推送服务 APNS，',
      goSetting: '请前往设置',
      onlyIOS: '仅限ios平台申请，点击可了解详情',
      stopUse: '该功能已停用，如需开通，请联系人工服务：400-870-1230',
      failOpen: '开通服务失败，可联系人工服务解决。',
      opening: '审批中...',
      successInfo: '申请邮件已发送，请等待审评。开通后24H可查看分析数据。',
      expiredWarning: '苹果官方推送服务证书',
      affectUse: '将影响卸载分析功能，',
      willExpired: '即将过期',
      haveExpired: '已经过期',
      goToUpdate: '请尽快前往更新。',
      title: '卸载分析',
      date: '日期',
      applyOpen: '立即申请开通',
      newuserDevice: '新增设备',
      uninstallDevice: '卸载设备',
      uninstallTip: '所选时段内，被检测到卸载了App的设备。检测延迟在48小时内',
      pureAddDevice: '净增设备',
      pureAddTip: '所选时段内，新增设备-卸载设备',
      newUserAndUninstall: '新增和卸载',
      dataRange: '数据范围：仅限ios平台活跃设备',
      newuserAvg: '新增设备均值',
      uninstallAvg: '卸载设备均值',
      pureAddAvg: '净增设备均值',
    },
    pageaccess: {
      tab1: '页面访问',
      tab2: '访问路径分析',
      checked: '查看',
      link: '页面转向',
      table: {
        page: '页面',
        name: '页面显示名',
        accessNum: '入口页次数',
        platform: '平台',
        userNum: '页面受访人数',
        pageFrequency: '页面受访（次数 | 比率）',
        alltimepro: '受访总时长占比',
        stay: '平均停留时长',
        leave: '离开率',
        trend: '走向',
      },
      index: {
        a: '页面受访人数',
        b: '页面受访次数',
        c: '页面受访比率',
        d: '受访总时长占比',
        e: '平均停留时长',
        f: '离开率',
        g: '注',
        h: '入口页次数',
      },
      explain: {
        a: '所选日期内，访问该页面的设备数。',
        b: '所选日期内，访问该页面的次数。',
        c: '所选日期内，访问此页面的访问次数占所有页面总访问次数的比例。',
        d: '所选日期内，对某页面的总浏览时长占全部页面浏览时长的比例。',
        e: '所选日期内，每次浏览此页面的平均时长。',
        f: '所选日期内，在此页面中，选择离开应用占此页面浏览次数的比例。',
        g: '为了保证运算速度，我们只提供最近一年的页面访问相关数据。如需更多，请联系我们。',
        h: '所选日期内，作为访问会话的入口页面（也称着陆页面）的次数。',
      },
    },
    exploration: {
      title: '数据探索',
      placeholder: '输入关键词搜索',
      save: '保存',
      create: '新建',
      addmetric: '添加指标',
      addDimension: '添加维度',
      prompt1: '请至少选择一个指标',
      prompt2: '请至少选择一个维度',
      prompt3: '请输入方案名后点击保存按钮',
      tip: {
        tip1: '删除成功',
        tip2: '更新成功',
        tip3: '添加成功',
      },
      query: {
        metric1: '指标',
        metric2: '指标',
        metric3: '维度',
        querydata: '查询数据',
      },
      explain: [{
        title: '累积设备',
        detail: '所选时间段内，统计到的设备总量。',
        key: 'totaluser',
      }, {
        title: '新增设备',
        detail: '所选时间段内，每日首次安装并且打开应用的设备数。一台设备，只在首次安装打开应用时计作新增设备，重复安装应用的设备不会重复计量。',
        key: 'newuser',
      }, {
        title: '活跃用户',
        detail: '应用所覆盖的设备中（不限定新增时间），在所选日期内至少使用过一次应用的设备数。',
        key: 'launchuser',
      }, {
        title: '日活',
        detail: '当日的活跃设备数。',
        key: 'daylaunchuser',
      }, {
        title: '周活',
        detail: '截至当日，最近一周（含当日的7天）活跃设备数。',
        key: 'weeklaunchuser',
      }, {
        title: '月活',
        detail: '截至当日，最近一月（含当日的30天）活跃设备数。',
        key: 'monthlaunchuser',
      }, {
        title: 'DAU/MAU',
        detail: '当日的日活跃设备数与30日活跃设备数的比值。',
        key: 'DAU/MAU',
      }, {
        title: '新增留存率',
        detail: '所选日期内的新增设备，在之后指定时间内还在使用应用的比例。',
        key: 'keepuser',
      }, {
        title: '活跃留存率',
        detail: '所选日期内的活跃设备，在之后指定时间内还在使用应用的比例。',
        key: 'keeplaunchuser',
      }, {
        title: '一次性用户',
        detail: '以新增一年以内且超过7天（不含查询当天）的用户为样本，计算其中只在新增当天活跃，后续再无活跃的用户数。以及这些用户占样本的比例。',
      }, {
        title: '卸载设备',
        detail: '所选时间段内，被检测到卸载了App的设备，检测延迟在48小时内。仅支持IOS平台。',
        key: 'uninstalluser',
      }, {
        title: '流失设备数',
        detail: '到某日为止，用户（活跃用户）刚好连续7/14/30天没有再使用过应用，将被视为一个流失。<br>例如：9号的7日流失用户：需要2号活跃过的用户，在3号-9号都没有再活跃过，算9号的一个7日流失。',
        key: 'loseuser',
      }, {
        title: '流失前使用天数',
        detail: '所选日期内，符合7/14/30日流失条件的设备中在流失前使用应用的天数。',
      }, {
        title: '流失前使用次数',
        detail: '所选日期内，符合7/14/30日流失条件的设备中在流失前使用应用的次数。',
      }, {
        title: '流失前使用时长',
        detail: '所选日期内，符合7/14/30日流失条件的设备中在流失前使用应用的时长。',
      }, {
        title: '回流设备数',
        detail: '符合7/14/30日流失条件的流失设备在某日再次使用应用，将视为当日的一个回流。回流设备可用于评估沉默设备唤醒活动的效果。例如，选择连续7日不使用应用作为流失条件，只要设备在2013-11-6到2013-11-12期间都没开启过应用，11月13日开启了应用，则该设备算作2013-11-13的一个回流设备。',
        key: 'keeplose',
      }, {
        title: '回访设备数',
        detail: '某日新增的设备中，在查询报表时的最近7日（不含今日）中还有使用的设备数。由于指标定义的限制，未计算在最近8日（含今日）新增设备的回访设备及占比。<br>例如: 2014.07.18日7日回访用户统计方式：<br>以2014.07.18号新增设备作为样本，在查看报表时的最近7日（不含当日）这段时间内有一台设备启动过两次，数据会显示为1。（是排重的）',
        key: 'retetionuser',
      }, {
        title: '7日回访设备',
        detail: '某日新增的设备中，在查询报表时的最近7日（不含今日）中还有使用的设备数。由于指标定义的限制，未计算在最近8日（含今日）新增设备的回访设备及占比。',
        key: 'retetionuser_retetion7',
      }, {
        title: '7日回访率',
        detail: '某日新增设备中的7日回访设备/该日的新增设备。',
        key: 'retetionuser_retetionrate7',
      }, {
        title: '版本升级设备',
        detail: '某日升级到此版本的设备数。',
        key: 'versionupdate',
      }, {
        title: '启动',
        detail: '应用被启动相关指标',
        key: 'startup',
      }, {
        title: '总启动次数',
        detail: '所选日期内，每日应用被启动的总次数。',
        key: 'startup_total',
      }, {
        title: '人均启动次数',
        detail: '该日平均每设备启动应用的次数。',
        key: 'startup_average',
      }, {
        title: '启动次数分布',
        detail: '所选日期内，单设备启动应用次数的不同次数分组分布。',
      }, {
        title: '启动时长',
        detail: '应用使用时长指标',
        key: 'usetime',
      }, {
        title: '单次使用时长',
        detail: '所选日期内，每次使用应用的时长均值。',
        key: 'usetime_single',
      }, {
        title: '人均使用时长',
        detail: '所选日期内，每个设备使用应用的时长均值。',
        key: 'usetime_average',
      }, {
        title: '单次使用时长分布',
        detail: '所选日期内，每次启动应用时长的不同长度分组分布。',
        key: 'usetime_singledistribute',
      }, {
        title: '使用间隔',
        detail: '指两次相邻启动的开始时间之差。',
        key: 'intervallevel',
      }, {
        title: '启动间隔',
        detail: '指两次相邻启动的开始时间之差。',
        key: 'startup_interval',
      }, {
        title: '首次使用',
        detail: '指设备新增后第一次打开使用应用的这次行为。',
      }, {
        title: '越狱和破解',
        detail: '所选日期内，新增设备中已越狱和破解设备数量相关指标。',
        key: 'jailbrokencreate',
      }, {
        title: '已越狱设备',
        detail: '所选日期内，新增设备中已越狱的设备数。',
        key: 'jailbroken',
      }, {
        title: '未越狱设备',
        detail: '所选日期内，新增设备中未越狱的设备数。',
        key: 'nojailbroken',
      }, {
        title: '越狱设备比例',
        detail: '所选日期内，新增设备中已越狱的设备占比。',
        key: 'jailbrokenpro',
      }, {
        title: '已越狱操作系统',
        detail: '所选日期内，新增设备中已越狱的操作系统。',
        key: 'created',
      }, {
        title: '未越狱操作系统',
        detail: '所选日期内，新增设备中未越狱的操作系统。',
        key: 'nocreated',
      }, {
        title: '越狱操作系统比例',
        detail: '所选日期内，新增设备中未越狱的操作系统占比。',
        key: 'createdpro',
      }, {
        title: '受访次数',
        detail: '所选日期内，访问该页面的设备数。',
        key: 'page_peoplenum',
      }, {
        title: '受访人数',
        detail: '所选日期内，访问该页面的次数。',
        key: 'page_time',
      }, {
        title: '停留时间',
        detail: '所选日期内，每次浏览此页面的平均时长。',
        key: 'page_staytime',
      }, {
        title: '离开率',
        detail: '所选日期内，在此页面中，选择离开应用占此页面浏览次数的比例。',
        key: 'page_leavepro',
      }, {
        title: '事件数',
        detail: '所选日期内，事件发生的次数。',
        key: 'event_time',
      }, {
        title: '达成事件设备数',
        detail: '所选日期内，触发某事件的设备数。',
        key: 'event_peoplenum',
      }, {
        title: '每启动发生次数',
        detail: '所选日期内，平均每次使用应用期间触发该事件的次数。',
        key: 'event_happen',
      }, {
        title: '每活跃设备发生率',
        detail: '所选日期内，平均每个活跃设备中触发了该事件的设备的比例。',
      }],
      selectTab: {
        title: '选择指标',
        title2: '选择维度',
        tab1: '设备及启动',
        tab2: '页面',
        tab3: '事件',
        page: '页面名称',
        event: '事件名称',
        prompt1: '无交叉维度，请重新添加指标',
      },
      xdimension: [{
        en: 'day',
        ch: '日期',
      }, {
        en: 'hour',
        ch: '小时',
      }, {
        en: 'partnerid',
        ch: '渠道',
      }, {
        en: 'version',
        ch: '版本',
      }, {
        en: 'userType',
        ch: '用户分群',
      }, {
        en: 'mobile',
        ch: '设备机型（设备型号）',
      }, {
        en: 'os',
        ch: '设备机型（操作系统）',
      }, {
        en: 'pixel',
        ch: '设备机型（分辨率）',
      }, {
        en: 'isp',
        ch: '运营商',
      }, {
        en: 'channel',
        ch: '网络',
      }, {
        en: 'country',
        ch: '地区（国家）',
      }, {
        en: 'province',
        ch: '地区（中国各省份）',
      }, {
        en: 'startlevel',
        ch: '设备数',
      }, {
        en: 'usetimelevel',
        ch: '单次使用时长',
      }, {
        en: 'intervallevel',
        ch: '启动间隔',
      }],
      metric: [{
        first: '累计设备',
        dimension: ['day'],
        metric: 'totaluser',
      }, {
        first: '新增用户',
        dimension: ['day', 'hour', 'partnerid', 'version', 'mobile', 'os', 'pixel', 'isp', 'channel', 'country', 'province'],
        metric: 'newuser',
      }, {
        first: '活跃用户',
        second: ['活跃设备', '周活', '月活', 'DAU/MAU'],
        dimension: ['day'],
        metric: 'launchuser',
        enSecond: ['daylaunchuser', 'weeklaunchuser', 'monthlaunchuser', 'DAU/MAU'],
      }, {
        first: '新增留存率',
        second: [],
        dimension: ['day'],
        metric: 'keepuser',
      }, {
        first: '活跃留存率',
        second: [],
        dimension: ['day'],
        metric: 'keeplaunchuser',
      }, {
        first: '卸载设备',
        dimension: ['day', 'partnerid', 'mobile', 'os', 'pixel', 'isp', 'channel', 'country', 'province'],
        metric: 'uninstallUser',
      }, {
        first: '流失用户',
        second: ['流失用户数(连续7日未使用应用)', '流失用户数(连续14日未使用应用)', '流失用户数(连续30日未使用应用)',
          // '流失前使用天数(连续7日未使用应用)', '流失前使用天数(连续14日未使用应用)', '流失前使用天数(连续30日未使用应用)',
          //     '流失前使用次数(连续7日未使用应用)', '流失前使用次数(连续14日未使用应用)', '流失前使用次数(连续30日未使用应用)',
          //     '流失前使用时长(连续7日未使用应用)', '流失前使用时长(连续14日未使用应用)', '流失前使用时长(连续30日未使用应用)'
        ],
        dimension: ['day'],
        metric: 'loseuser',
        enSecond: ['loseuser_loseuser7', 'loseuser_loseuser14', 'loseuser_loseuser30',
          // 'loseuser_loseday7', 'loseuser_loseday14', 'loseuser_loseday30',
          // 'loseuser_losetime7', 'loseuser_losetime14', 'loseuser_losetime30',
          // 'loseuser_loselong7', 'loseuser_loselong14', 'loseuser_loselong30'
        ],
      }, {
        first: '回流用户',
        second: ['回流用户数(连续7日未使用应用)', '回流用户数(连续14日未使用应用)', '回流用户数(连续30日未使用应用)'],
        dimension: ['day'],
        metric: 'keeplose',
        enSecond: ['keeplose_user7', 'keeplose_user14', 'keeplose_user30'],
      }, {
        first: '回访用户',
        second: ['7日回访用户', '7日回访率'],
        dimension: ['day'],
        metric: 'retetionuser',
        enSecond: ['retetionuser_retetion7', 'retetionuser_retetionrate7'],
      }, {
        first: '版本升级用户',
        dimension: ['day'],
        metric: 'versionupdate',
      }, {
        first: '启动',
        second: ['启动次数', '人均启动次数'],
        dimension: ['day'],
        metric: 'startup',
        enSecond: ['startup_total', 'startup_average'],
      }, {
        first: '启动时长',
        second: ['单次使用时长', '人均使用时长', '单次使用时长分布'],
        dimension: ['day'],
        metric: 'usetime',
        enSecond: ['usetime_single', 'usetime_average', 'usetime_singledistribute'],
      }, {
        first: '启动间隔分布',
        dimension: ['day'],
        metric: 'intervallevel',
        groupby: 'intervallevel',
        second: ['启动间隔分布'],
        enSecond: ['startup_interval'],
      }, {
        first: '越狱和破解',
        second: ['已越狱设备', '未越狱设备', '越狱比例', '已破解设备', '未破解设备', '破解比例'],
        dimension: ['mobile'],
        metric: 'jailBreakcrack',
        enSecond: ['jailbroken', 'nojailbroken', 'jailbrokenpro', 'created', 'nocreated', 'createdpro'],
      }],
      pageAndEvent: [{
        first: '页面名称',
        second: ['受访次数', '受访人数', '停留时间', '离开率'],
        dimension: ['day'],
        enSecond: ['page_time', 'page_peoplenum', 'page_staytime', 'page_leavepro'],
      }, {
        first: '事件名称',
        second: ['发生次数', '达成人数', '每启动发生次数'],
        dimension: ['day'],
        enSecond: ['event_time', 'event_peoplenum', 'event_happen'],
      }],
      // 用户数据探索指标的中英切换
      namelist: {
        _totaluser: '累计设备',
        _newuser: '新增用户',
        _launchuser: '活跃用户',
        daylaunchuser: '活跃设备',
        weeklaunchuser: '周活',
        monthlaunchuser: '月活',
        daumau: 'DAU/MAU', // 特殊处理key
        _keepuser: '新增留存率',
        _keeplaunchuser: '活跃留存率',
        _loseuser: '流失用户',
        loseuser_loseuser7: '流失用户数（连续7日未使用）',
        loseuser_loseuser14: '流失用户数（连续14日未使用）',
        loseuser_loseuser30: '流失用户数（连续30日未使用）',
        loseuser_loseday7: '流失前使用天数（连续7日未使用）',
        loseuser_loseday14: '流失前使用天数（连续14日未使用）',
        loseuser_loseday30: '流失前使用天数（连续30日未使用）',
        loseuser_losetime7: '流失前使用次数（连续7日未使用）',
        loseuser_losetime14: '流失前使用次数（连续14日未使用）',
        loseuser_losetime30: '流失前使用次数（连续30日未使用）',
        loseuser_loselong7: '流失前使用时长（连续7日未使用）',
        loseuser_loselong14: '流失前使用时长（连续14日未使用）',
        loseuser_loselong30: '流失前使用时长（连续30日未使用）',
        _keeplose: '回流用户',
        keeplose_user7: '回流用户数（连续7日未使用）',
        keeplose_user14: '回流用户数（连续14日未使用）',
        keeplose_user30: '回流用户数（连续30日未使用）',
        _retetionuser: '回访用户',
        retetionuser: '7日回访用户',
        retetionuser_retetion7: '7日回访用户',
        retetionuser_retetionrate7: '7日回访率',
        _versionupdate: '版本升级用户',
        _startup: '启动',
        _intervallevel: '启动间隔分布',
        startup: '启动次数',
        startup_average: '人均启动次数',
        _usetime: '启动时长',
        usetime_single: '单次使用时长',
        usetime_average: '人均使用时长',
        usetime_singledistribute: '单次使用时长分布',
        startup_interval: '启动间隔分布',
        _jailBreakcrack: '越狱和破解',
        jailbroken: '已越狱设备',
        nojailbroken: '未越狱设备',
        jailbrokenpro: '越狱比例',
        created: '已破解设备',
        nocreated: '未破解设备',
        createdpro: '破解比例',
        page_time: '受访次数',
        page_peoplenum: '受访人数',
        page_staytime: '停留时间',
        page_leavepro: '离开率',
        event_time: '发生次数',
        event_peoplenum: '达成人数',
        event_happen: '每启动发生次数',
      },
    },
    version: {
      platform: '平台',
      appversion: '应用版本',
      createtime: '创建时间',
      state: '报表显示状态',
      code: '最新VersionCode',
      updatetime: '更新时间',
      sdkversion: 'SDK版本',
      show: '显示',
      hide: '隐藏',
      pagesize: '条/页'
    },
    accountAuthorization: {
      title: '账户与授权',
      createNewUser: '新建授权账户',
      delete: '删除',
      username: '用户名',
      role: '角色',
      remarks: '备注',
      jurisdiction: '权限',
      createtime: '创建时间',
      operate: '操作',
      creator: '创建者',
      ordinaryuser: '普通用户',
      partneruser: '渠道合作伙伴',
      pagesize: '条/页',
      del: '是否确定删除用户？',
    },
    authorize: {
      createAuthor: '新建授权账户',
      editAuthor: '编辑授权信息',
      modal: {
        content: '您已授权该账户，点击确定进入编辑模式'
      },
      messageInfo: {
        addsucc: '添加成功',
        addfail: '添加失败，请重试',
        editsucc: '编辑成功',
        editfail: '编辑失败，请重试',
      },
      account: {
        title: '账号',
        placeholder: '请输入被授权用户的Email',
        prompt: '账户不可为空',
        nameErr: '请输入正确的邮箱格式',
        nameIsMySelf: '不支持给您自己进行授权',
      },
      remarks: {
        title: '备注',
        placeholder: '请输入相关信息如联系人信息，公司信息等(50字以内)',
      },
      role: {
        title: '角色',
        ordinaryUser: '普通用户',
        partner: '渠道合作伙伴',
        administrators: '管理员',
      },
      selApp: {
        title: '选择应用',
        addApp: '添加授权应用',
        modaltitle: '请选择应用',
        selected: '已选择',
        selectedApp: '已选应用',
        num: '个',
        app: '应用',
        channel: '渠道',
        all: '全部',
        total: '共',
        type: '款',
        prompt: '请至少选择一款应用',
        nopage: '请至少授权一个页面',
      },
      channelAuthorize: {
        title: '分渠道授权',
        all: '全部渠道',
        part: '部分渠道',
        prompt: '请选择至少一个渠道',
      },
      dataAuthorize: {
        title: '数据权限',
        all: '全部数据权限',
        jurisdiction: '渠道分析（新增、活跃及累计）',
      },
      manageAuthorize: {
        all: '应用管理',
      },
    },
    manageEvent: {
      tabs: {
        list: '事件列表',
        pending: '待处理事件',
        recycle: '事件回收站',
      },
      table: {
        displayname: '事件名称',
        eventid: '事件ID',
        eventlabel: 'Label',
        platformid: '平台',
        registertime: '登记时间',
        changetime: '修改时间',
        labellimit: 'Label状态',
        operation: '操作',
        deletetime: '删除时间',
        normal: '正常',
        excess: '过量使用',
        edit: '编辑',
        labelmanage: 'Label管理',
        calculation: '开始计算',
        recovery: '恢复',
        del: '删除',
      },
      modal: {
        listdel: {
          testing: '经检测',
          funnelInfo: '等多个事件已被用于构建转化漏斗分析，删除后相应的转化漏斗也将被删除。此外，',
          a: '删除后将不再计算这些事件的数据，并将移至事件回收站。',
          b: '如需重新开始计算，请从事件回收站找到相应事件并确认‘恢复’。',
          c: '是否确定删除事件？',
        },
        pendingdel: {
          a: '删除后将移至事件回收站。',
          b: '如需重新开始计算，请从事件回收站找到相应事件并确认‘恢复’。',
          c: '是否确定删除事件？',
        },
        recycledel: {
          a: '从回收站删除后，所选事件将被永久删除，即便再次添加相同ID的事件，也无法采集相应的事件数据。',
          b: '是否确定永久删除事件？',
        },
        pendingreduce: {
          a: '确认开始计算后，此事件将被移入事件列表并开始对其进行计算。',
          b: '请合理保留需要计算的事件，过多事件参与计算将影响报表速度。',
          c: '是否确定开始计算此事件？',
        },
        add: {
          a: '如确认恢复，将恢复至删除前的位置。如果删除前位于事件列表内，恢复后则开始计算；如删除前位于待处理事件组，恢复后依然无法开始计算，需从待处理事件内手动确认‘开始计算’后才能参与计算。',
          b: '是否确定恢复此事件？',
        },
      },
      index: {
        a: ': 正常进行数据计算的事件。 ',
        b: ': 存放您删除掉的事件，删除后不再进行计算，您可随时恢复他们。',
        c: ': 在您的事件项超过1000后，更多事件会进入待处理状态，您需要手动开通，从开通时间开始计算。 ',
        d: ': 为事件ID重命名，便于分析中快速识别所需事件。',
        e: ': 首次统计到此事件的日期。',
        f: ': 最后一次修改事件的时间。包括移动到回收站，从回收站、待处理列表移动到事件列表、重命名等。',
        g: ': 事件删除后，将被移动到回收站，服务器将不再接收对应事件ID的数据，直至事件被恢复使用为止。',
        h: ': 表示Label现在或者曾经达到过量的状态，一般分为正常和过量使用。正常，表示所有Label都在计算中，无需手动操作。过量使用，表示Label数量现在或者曾经超过限量，新Label需要手动添加到计算列表。',
      },
    },
    manageLabel: {
      tabs: {
        labellist: 'Label列表',
        pending: '待处理Label',
        recycle: 'Label回收站',
      },
      modal: {
        labellistdel: {
          a: '删除后将不再计算这些Label的数据，并将移至Label回收站。',
          b: '如需重新开始计算，请从Label回收站找到相应Label并确认‘恢复’。',
          c: '是否确定删除Label？',
        },
        pendingdel: {
          a: '删除后将移至Label回收站。',
          b: '如需重新开始计算，请从Label回收站找到相应事件并确认‘恢复’。',
          c: '是否确定删除Label？',
        },
        recycledel: {
          a: '从回收站删除后，所选Label将被永久删除，即便再次添加相同ID的Label，也无法采集相应的Label数据。',
          b: '是否确定永久删除Label？',
        },
        pendingreduce: {
          a: '确认开始计算后，此Label将被移入Label列表并开始对其进行计算。',
          b: '请合理保留需要计算的Label，过多Label参与计算将影响报表速度。',
          c: '是否确定开始计算此Label？',
        },
        add: {
          a: '如确认恢复，将恢复至删除前的位置。如果删除前位于Label列表内，恢复后则开始计算；如删除前位于待处理Label内，恢复后依然无法开始计算，需从待处理Label内手动确认‘开始计算’后才能参与计算。',
          b: '是否确定恢复此Label？',
        },
      },
    },
    manageInfo: {
      info: '基本信息',
      form: {
        appName: '应用名称',
        appIcon: '应用图标',
        appType: '应用类型',
        platform: '应用平台',
        showWatch: 'Watch数据',
        watchOn: '显示',
        watchOff: '关闭',
        createDate: '创建日期',
        appId: 'App ID',
        copyId: '复制',
        authorize: '授权人',
        saveInfo: '保存',
        deleteApp: '删除应用',
        deleteConfirm: '删除后，应用及其数据均被删除，无法恢复。是否确定删除此应用？',
        deleteAuthority: '取消应用授权',
      },
      tip: {
        imgOverSize: '超出文件大小限制',
        imgOverSizeDecs: '上传文件不能超过500KB',
        copySuccessTip: '复制成功！',
        copyErrorTip: '操作失败！',
        deleteProSuccess: '删除产品成功',
        deleteProError: '删除产品失败',
        saveSuccess: '保存成功',
        saveError: '保存失败',
        saveNameDuplicate: '产品名称已存在',
        formatErrorTitle: '文件格式不正确',
        formatErrorDesc: '请上传 jpg 或 png 格式的图片',
      },
      footer: {
        sdk: 'SDK下载',
        doc: '集成文档',
        item: '服务条款',
        privacy: '隐私政策',
        blog: '博客',
        phone: '联系方式',
        qq: '客服QQ',
        email: '客服邮箱',
        copyright1: '京ICP备12005794号',
        copyright2: '京ICP证130311号',
        copyright3: '京公网安备11010102001221号',
      },
    },
    openApi: {
      title: '数据接口',
      accessKey: '数据接入码',
      applyCode: '申请数据接入码',
      applyTip: '您的用户量过低，暂时无法申请数据接入码',
      validIP: '添加有效服务器IP',
      invalidIP: '此IP地址不合法',
      copy: '复制',
      saveIP: '保存',
      cancel: '取消',
      editIP: '编辑',
      deleteIP: '删除',
      deleteTip: '您确定删除此IP吗？',
      intro: {
        title: '数据接口简介',
        desc: ['数据接口可以帮助您把TalkingData中计算好的数据取走，这样您可以单独存储一份重要数据，亦可在您的内部系统中组织一套自己的运营报表， 利用TalkingData能力获得属于您自己的分析后台。',
          '1、为了调用的安全，您需要先为应用获取 Access Key，这是获取数据时需要携带的安全凭证。首次申请的Access Key，生效时间为半小时左右。',
          '2、您需要提供调用接口的服务器IP地址，只有您许可的IP才有调用数据的权利，这能确保仿冒调用获取不到数据。',
          '3、为保障调用效率，每款产品需要积累用户超过 1000 后，才能申请数据接口。',
          '4、为了保障数据安全，每款应用最多同时支持5个不同IP通过API方式获取数据。',
        ],
        helpDoc: '数据接口调用指南',
      },
      tip: {
        copySuccess: '复制成功！',
        copyError: '操作失败！',
      },
    },
    manageChannel: {
      title: '渠道列表',
      num: '个',
      validTips: '请选择有效渠道',
      table: {
        platformid: '平台',
        partnername: '渠道ID',
        displayname: '渠道名称',
        registertime: '登记时间',
        channelstr: '渠道合并',
        isdisplay: '报表显示状态',
        channelmanage: '渠道授权',
        authorized: '授权账号数',
        query: '查询权限(老版)',
        querylink: '>>渠道后台',
        show: '显示',
        hide: '隐藏',
        merge: '合并',
        split: '拆分',
        mergeinfo: '多个渠道数据合并',
        splitinfo: '已合并渠道数据重新拆分为不同渠道，分别展示',
        userPass: '授权账户及密码',
        user: '账户',
        password: '密码',
        splitMerge: '合并/拆分渠道',
      },
      queryinfo: {
        a: '原有渠道合作伙伴授权查询数据的方式将',
        b: '在2017-6-1起正式下线，我们已为您提供',
        c: '更安全，便捷的渠道授权方式，欢迎体验！',
        t: '老版本渠道授权方式下线提醒',
        btn: '进入老版渠道后台',
      },
      modal: {
        merge: {
          title: '请选择进行合并的渠道（只支持同平台下的渠道进行合并）',
          number: '已选渠道',
        },
        split: {
          title: '本渠道将拆分为以下不同渠道，分别计算',
          number: '拆分渠道',
        },
      },
      index: {
        a: ': 为渠道ID重命名为更加熟悉的渠道名称，便于识别。TalkingData提供了市场常见的渠道名称，建议尽量按已标准化的渠道名称进行重命名。',
        b: ': 首次统计到此渠道数据的日期。',
        c: ': 隐藏渠道后，渠道将不显示在渠道分析、筛选渠道等相关功能的列表里。此功能，可以避免太多无效渠道影响报表展示。',
        d: ': 合并功能可以将任意的渠道进行汇聚，查看聚合后的数据。拆分功能则可以将已合并的渠道重新按单个渠道进行展示。',
      },
    },
    manageAlerts: {
      alert: '预警通知',
      history: '预警历史记录',
      name: '预警规则名称',
      conditions: '预警条件',
      receiver: '预警接收方',
      status: '使用状态',
      normal: '正常',
      diable: '停用',
      delete: '删除',
      add: '创建',
      new: '预警规则',
      time: '预警发生时间',
      content: '预警内容',
      notice: '邮件通知',
      mail: '接受预警通知的邮箱',
      addmail: '添加邮箱地址',
      metrics: {
        title: '监控指标',
        new: '新增用户',
        channal: '渠道新增用户',
        active: '活跃用户',
        session: '启动次数',
        event: '事件数',
        err: '错误次数',
      },
      range: {
        title: '计算范围',
        day: '全天',
        am: '每日8时',
        pm: '每日15时',
      },
      evalue: {
        title: '评估方式',
        gt: '高于',
        let: '低于',
        pre: '前一日',
        num: '绝对值',
      },
      threshold: {
        title: '阈值',
        percent: '百分比',
        num: '数值',
      },
      errInfo: {
        a: '阈值不能为空',
        b: '请输入取值为正整数的阈值',
        c: '阈值不能为空',
        d: '请填写正确的邮箱地址',
        e: '邮箱地址不能为空',
        f: '预警规则名称不能为空',
        g: '预警规则名称不能超过64个字符',
        h: '请输入100以内的数，可保留两位小数',
      },
      delInfo: [
        '是否确定删除这些预警规则？',
        '是否确定删除这些预警历史？',
      ],
    },
    smart: {
      title: '配置灵动事件',
      intro: {
        title: '什么是“灵动事件”',
        desc: '脱离代码，您只需面对应用界面圈圈点点即可追加随时生效的事件数据点',
        helpView: '点我,观看演示视频'
      },
      closeTip: {
        tipResult: '请您稍后再尝试使用！',
        tipIntro1: '您团队的其他成员正在管理灵动事件，为确保相互操作不受干扰，',
        tipIntro2: '您暂时无法使用，请稍后尝试'
      },
      connectTip: {
        openApp: '在设备上打开您的应用',
        timeTip: {
          startCon: '在刚打开的前',
          midCon: '秒内摇动设备',
          endCon: '次'
        },
        openTip: '（需应用后台进程关闭状态下初次打开）',
        processStatus: '尝试连接中…'
      },
      connectSteps: {
        stepOne: '摇一摇，连接一台设备',
        stepOneScan: '扫一扫，连接一台设备',
        stepTwo: '平台自动获取连接设备当前界面',
        stepThree: '选择界面中的元素来追加事件',
        stepFour: '事件生效，开始获取数据',
        stepDemo: '点我,观看演示视频'
      },
      attention: {
        title: '注意事项',
        verTip: '使用灵动事件，请使用新版SDK',
        iosSDK: 'iOS SDK V2.0beta 及以上版本',
        iosSDK4: 'iOS SDK V4.0.41 及以上版本',
        androidSDK: 'Android SDK V2.0beta 及以上版本',
        androidSDK4: 'Android SDK V4.0.36 及以上版本',
        networkTip: '请在WiFi环境下使用本功能'
      },
      connectInfo: {
        shakeTime: '摇一摇时间',
        isConnect: '侦测到一台设备，连接它吗？',
        connect: '连接',
        reject: '拒绝'
      },
      errorTip: '获取数据失败，请重试',
      traceText: {
        openTip: '在界面中对可追踪数据的元素追加提示',
        closeTip: '关闭在界面中对可追踪数据的元素追加提示',
        traceable: '可追踪的元素',
        hasTrace: '已追踪的元素',
        curEle: '当前选中的元素'
      },
      disconnect: {
        disBtn: '断开连接',
        eventName: '事件测试',
        happenTime: '发生时间',
        isVaild: '对用户生效',
        vaild: '已生效',
        invaild: '未生效',
        noEvent: '请在您的设备上点击已添加事件的按钮！'
      },
      addEvent: {
        title: '命名事件，追加数据追踪点',
        subTitle: '在用户点击这个界面元素时收集数据',
        placeholder: '键入事件名称',
        hasExist: '事件名已存在，请更换一个',
        comfirm: '确定',
        cancel: '取消'
      },
      editEvent: {
        allEvent: '全部事件',
        curPageEvent: '当前页事件',
        hasChangeEvent: '有变更事件',
        searchEvent: '输入检索词',
        confirm: '确定',
        cancel: '取消',
        lastSaveTime: '最后保存时间',
        pushAll: '全部生效',
        cancelEdit: '撤销更改',
        pushSuccessTip: '全部提交已生效',
        pushErrorTip: '全部提交失败',
        cancelEditTip: '本次更改已撤消',
        cancelErrorTip: '撤消更改失败',
        noSaveEvent: '您还没有保存过事件'
      }
    },
    eauth: {
      welcome: {
        title: '易认证 - 轻松搞定用户真实性认证',
        description: '集成简单、界面自由、通道稳定、免费赠量，助力您集中精力做好产品',
        smsTitle: '注册短信认证',
        smsDes: '采用手机号注册的产品，我们帮助您轻松完成短信认证',
        phoneTitle: '绑定手机激励',
        phoneDes: '激励您的用户，可选性的进行手机认证，给予虚拟奖励。有助您与用户的持续联络沟通',
        passwordTitle: '临时密码认证',
        passwordDes: '在用户忘记密码时，使用最快捷的短信认证方式临时授权访问，快速重设新密码，避免流失',
        dredge: '立即开通使用',
        toUse: '开始使用',
        knowMore: '了解易认证集成方式'
      },
      overview: {
        appid: '客户端集成使用的产品唯一标识',
        secretid: '客户端集成时的安全认证码',
        serverSecurity: '在您采用服务器端校验认证结果时，需携带此码，用于安全验证',
        integretionInfo: '立即集成，获得免费认证短信量',
        gotIntegeretion: '快速集成',
        balance: '本月发起短信认证人次',
        sendoutAll: '本月短信成功认证人次',
        verifyAll: '本月发起SAI安全认证人次',
        remainFree: '本月SAI安全成功认证人次',
        free: '免费额度',
        perday: '条/日',
        more: '获取更多',
        trend: '认证趋势',
        times: '按次数',
        phone: '按手机号',
        device: '按设备数',
        day7: '近7日',
        day30: '近30日',
        today: '今日',
        yesday: '昨日',
        month: '本月',
        day: '日',
        hour: '时',
        apply: '成功申请数',
        sendout: '短信发送量',
        verify: '成功认证量',
        rate: '认证完成率'
      },
      list: {
        des: '我们为您提供最近两个月内的认证清单',
        status: '认证状态',
        phoneNum: '手机号码',
        attribution: '归属地',
        dev: '设备ID',
        carriers: '运营商',
        sendTime: '短信发送时间',
        authTime: '认证成功时间'
      },
      message: {
        des: '定制产品名称，获取1000条/日免费流量；申请专属短信通道，可设置签名，免费流量提升至10000条/日',
        dedicate: '查看短信设置/流量获取说明',
        name: '产品名称',
        nameDefine: '产品名称可定制；默认签名为【易认证】，申请专属短信通道可修改',
        code: '认证码提示',
        codeDefine: '系统自动帮助您填充认证码，不需要输入',
        addition: '短信附加信息',
        additionDefine: '短信附加信息暂时不能修改',
        example: '示例'
      }
    },
    datachart: {
      msgerror: '数据加载失败',
      countryTable: '国家明细',
      regionTable: '省市明细 (注：不含港澳台地区)',
      country: '国家',
      region: '地区',
      newuser: '新增用户',
      newuserProportion: '新增占比',
      launchuser: '活跃用户',
      launchuserProportion: '活跃占比',
      startup: '启动次数',
      daylaunchuser: '日活跃DAU',
      weeklaunchuser: '周活跃WAU',
      monthlaunchuser: '月活跃MAU',
      daumau: 'DAU/MAU',
      onceuser: '一次性用户',
      loseuser: '流失用户',
      backuser: '回流用户',
      retetionuser: '回访用户',
      starttime: '启动时长',
      uninstalluser: '卸载设备',
      uninstallUser: '卸载设备',
      jailbroken: '已越狱',
      nojailbroken: '未越狱',
      jailbrokenpro: '越狱比例',
      versionupdate: '升级用户',
      created: '已破解',
      nocreated: '未破解',
      createdpro: '破解比例',
      intervallevel: '使用间隔明细',
      startup_interval: '次数',
      totaluser: '累积用户',
      partnerid: '渠道名称',
      version: '版本号',
      channel: '网络',
      isp: '运营商',
      pixel: '设备机型（分辨率）',
      os: '设备机型（操作系统）',
      userType: '用户分群',
      mobile: '设备机型（设备型号）',
      startup_average: '人均启动次数',
      startlevel: '启动次数',
      startup_startuptime: '设备数',
      retetionuser_retetionrate7: '7日回访率',
      retetionuser_retetion7: '7日回访用户',
      usetime_singledistribute: '单次使用时长分布',
      usetimelevel: '单次使用时长明细',
      usetime_average: '人均使用时长',
      usetime_single: '单次使用时长',
      keeplose_user7: '回流用户数（连续7日未使用）',
      keeplose_user14: '回流用户数（连续14日未使用）',
      keeplose_user30: '回流用户数（连续30日未使用）',
      loseuser_loseuser7: '流失用户数（连续7日未使用）',
      loseuser_loseuser14: '流失用户数（连续14日未使用）',
      loseuser_loseuser30: '流失用户数（连续30日未使用）',
      loseuser_loseday7: '流失前使用天数（连续7日未使用）',
      loseuser_loseday14: '流失前使用天数（连续14日未使用）',
      loseuser_loseday30: '流失前使用天数（连续30日未使用）',
      loseuser_losetime7: '流失前使用次数（连续7日未使用）',
      loseuser_losetime14: '流失前使用次数（连续14日未使用）',
      loseuser_losetime30: '流失前使用次数（连续30日未使用）',
      loseuser_loselong7: '流失前使用时长（连续7日未使用）',
      loseuser_loselong14: '流失前使用时长（连续14日未使用）',
      loseuser_loselong30: '流失前使用时长（连续30日未使用）',
      keepuser: '日（新增留存率）',
      keeplaunchuser: '日（活跃留存率）',
      page_time: '页面受访次数',
      page_leavepro: '页面离开率',
      page_staytime: '页面停留时间',
      page_peoplenum: '页面受访人数',
      event_time: '事件发生次数',
      event_happen: '事件每发生次数',
      event_peoplenum: '事件达成人数',
    },
    eventAnalysis: {
      title: '事件分析',
      table: '事件列表',
      jumpinfo: '增加灵动事件',
      event: '全部事件',
      smart: '灵动事件',
      // code: '代码事件',
      custom: '自定义事件',
      standard: '标准事件',
      eventname: '事件名称',
      eventid: '事件ID',
      eventtype: '事件类型',
      platform: '平台',
      eventuser: '事件达成用户数',
      eventcount: '事件数',
      eventhappen: '每启动发生次数',
      set: '操作',
      index: {
        a: ': 所选日期内，事件发生的次数。',
        b: ': 所选日期内，触发某事件的设备数。',
        c: ': 所选日期内，平均每次使用应用期间触发该事件的次数。',
        d: '注：为了保证运算速度，我们只提供最近一年的自定义事件相关数据。如需更多，请联系我们。',
      },
    },
    eventdetails: {
      day: '日期',
      diff: '对比',
      diffdate: '对比时段',
      pro: '日均',
      title: '事件',
      trend: '事件趋势',
      trenddetails: '事件详情',
      analysis: '参数分析',
      label: 'Label',
      eventvalue: 'Value',
      eventcount: '事件数',
      eventuser: '事件达成用户数',
      happen: '每活跃用户发生率',
      startup: '每启动发生数',
      eventcountDiff: '事件数(对比)',
      eventuserDiff: '事件达成用户数(对比)',
      happenDiff: '每活跃用户发生率(对比)',
      startupDiff: '每活跃用户发生率(对比)',
      options: '参数',
      value: 'Value',
      info: '总消息数',
      addValue: 'Value合计值',
      set: '操作',
      setVal: 'Value分布',
      labelTable: 'Label分布',
      eventLabel: '事件标签',
      details: '详情',
      up: '收起',
      proportion: '占比',
      proportionTotal: '累计占比',
      top100: 'Top100',
      eventOption: '事件参数名称',
      eventOptionNum: '事件参数值',
      eventLabelDis: '事件参数分布',
      top100label: '参数的Top100Label分布',
      top100option: 'Label的Top100参数分布',
      index: {
        a: ': 所选日期内，事件发生的次数。',
        b: ': 所选日期内，触发某事件的设备数。',
        c: ': 所选日期内，平均每个活跃设备中触发了该事件的设备的比例。',
        d: ': 所选日期内，平均每次使用应用期间触发该事件的次数。',
      },
      optionIndex: {
        a: ': 追踪事件时，同时添加的描述行为的参数名称。',
        b: ': 各事件参数所记录的不同参数值。',
        c: ': 所选日期内，每个事件参数的发生次数及其不同参数值的发生次数。',
        d: ': 所选日期内，某个参数的所选参数值在Top 100事件标签下的发生次数。',
        e: ': 所选日期内参数某个取值的发生次数/全部取值发生次数的比例。',
        f: ': 按照占比从上而下的累计，累计到最后一项时，就是100%。比如第二种商品累计占比为第一、二种所占比例之和，第三种商品累计占比为第一、二、三种所占比例之和，以此类推至到100%。这种方式可以直观显示随类别增加，所显示类别的所占比例之和，直观看出贡献率较高的参数值。',
      },
      labelIndex: {
        a: ': 在追踪事件时，TalkingData App Analytics提供了事件标签（Label），便于给多个要跟踪的同类型或类似的事件使用相同的EventID，通过给他们分配不同事件标签，进而实现区分跟踪多个事件的目的。',
        b: ': 所选日期内，每个事件标签的发生次数。',
        c: ': ',
      }
    },
    funnel: {
      title: '转化漏斗',
      funnelBtn: '新建转化漏斗',
      setfunnel: '编辑转化漏斗',
      edit: '编辑',
      set: '操作',
      addStep: '新增步骤',
      funnelInfo: '以用户触发的事件为依据，构造转化漏斗，系统将逐步过滤，计算出用户在整个过程中的转化率。',
      funnelname: '转化漏斗名称',
      start: '起始步骤',
      placeholder: '选择用户触发事件',
      end: '转化目标',
      step: '步骤',
      null: '不能为空',
      name: '名称',
      event: '事件',
      analysis: '分析依据',
      stepname: '步骤名称',
      repeatStepName: '步骤名称重复，请重新输入。',
      update: '修改成功',
      create: '创建成功',
      delinfo: '是否确定删除此转化漏斗？',
      eventdelinfo: '该事件已被删除',
      rate: '总体转化率 ',
      number: '总人数',
      achieve: '达成目标人数',
      noAchieve: '未达成目标人数',
      lowRate: '转化率最低的步骤',
      details: '转化漏斗详情',
      eventuser: '用户数',
      preRate: '较上一步转化率',
      noLess: '不得少于两步',
      stepNumber: ['第一步：', '第二步：', '第三步：', '第四步：', '第五步：', '第六步：', '第七步：', '第八步：'],
      targetStep: {
        name: '第',
        name2: '步',
        colon: '：',
      },
    },
    portrait: {
      info: ['样本：', '期间活跃设备'],
      sex: '性别分布',
      age: '年龄分布',
      pre: '人群特征TGI指数',
      people: '人群特征',
      equ: '移动应用偏好',
      man: '男',
      woman: '女',
      unknown: '未知',
      // agegroup: ['<19', '19-25', '26-35', '36-45', '46-55', '>55', '未知'],
      agegroup: ['<17', '18-24', '25-29', '30-34', '35-39', '40-44', '45-49', '>50', '未知'],
      indexInfo: '数据指标说明',
      indexbtn: {
        a: '如何获取更多性别信息？',
        b: '如何获取更多年龄分布信息？'
      },
      index: {
        a: '默认计算每个自然周内Android平台下活跃设备的画像。数据更新时间：活跃后，第4周周一更新数据。',
        b: ': TalkingData依据用户对应用的使用情况预测用户的性别，这个性别是指用户的行为特征性别，与用户身份证记录的性别有一定差异。',
        c: ': TalkingData依据对用户使用应用的行为的研究预测用户的年龄分布。',
        d: ':（具有当前人群特征的设备数/活跃设备总数）/（TalkingData全量设备中具有相同人群特征的设备数/TalkingData全量设备总数）*100。',
        e: ': 设备的应用偏好标签。',
        f: ':  根据各大主要移动设备卖场公布的设备特征对设备进行分类并统计样本中各类设备的占比。',
      }
    },
    errlist: {
      title: '错误列表',
      detail: '错误详情',
      log: '原始Log',
      news: '基本信息',
      searchplace: '按错误类型或错误摘要搜索',
      searchplace2: '按错误详情搜索',
      prev: '上一条',
      next: '下一条',
      prompt1: '当前已经是第一类错误！',
      prompt2: '当前已经是最后一类错误',
      table: {
        columnt: '错误类型',
        columne: '错误摘要',
        column2: '最后一次发生时间',
        column3: '今日发生次数',
        column4: '7日发生次数',
        column5: '时段内总次数',
      },
      modaltab: {
        column1: '受影响版本（Version Code）',
        column2: '最近出现时间',
        column3: '最近出现版本',
        column4: '今日出现次数',
        column5: '7日出现次数',
        column6: '累积发生次数',
      },
      charts: {
        mobile: '机型',
        os: '操作系统',
        version: '应用版本'
      }
    },
    errorAnalytics: {
      title: '错误分析',
      trend: '错误趋势',
      version: 'Top10 版本错误分布',
      versionCode: 'Top10 渠道错误分布',
      equipment: 'Top10 设备错误分布',
      system: 'Top10 操作系统错误分布',
      error: '错误次数',
      errorpro: '错误率',
      dayPro: '日均错误率',
      errorTime: '日均错误次数',
      index: {
        a: ': 所选日期内，错误发生总次数',
        b: ': 所选日期内，错误次数/启动次数'
      }
    },
    // 复购分析
    repeatShopping: {
      title: '复购分析',
      week: '周',
      month: '月',
      repeat: '复购率',
      table: {
        date: '日期',
        avg: '有效均值',
        pay: '付费设备数',
      },
      explain: {
        repeat: '支付订单的设备数在+N周/月再次支付订单的设备数',
        avg: '判断+n是否是未来日期或没有完全结束的日期，是的话不参与计算',
      },
    },
    // 交易分析
    transaction: {
      analytics: '交易分析',
      payrate: '新增设备付费率',
      date: '时间段',
      day: '日',
      week: '周',
      month: '月',
      index: {
        analytics: {
          a: ': 所选时段内订单的次数',
          b: ': 所选时段内生成过订单的独立设备数',
          c: ': 所选时段内支付订单的金额合计值',
          d: ': 支付订单金额 / 活跃设备数',
          e: ': 新增当天支付订单设备',
          f: ': 非当日新增设备中首次付费的设备',
          g: ': 非当日新增设备中非首次付费的设备',
          h: ': 所选时段内支付订单的次数',
          r: ': 支付订单数 / 订单数',
        },
        payrate: {
          a: ': 新增设备在新增当日支付订单的比例',
          b: ': 新增设备在新增当周支付订单的比例',
          c: ': 新增设备在新增当月支付订单的比例',
        },
      },
      order: {
        tabs: '下单',
        day: {
          orderVol: '日均下单量',
          orderDev: '日均下单设备',
        },
        week: {
          orderVol: '周均下单量',
          orderDev: '周均下单设备',
        },
        month: {
          orderVol: '月均下单量',
          orderDev: '月均下单设备',
        },
        placeOrderCount: '下单量',
        placeOrderDevice: '下单设备',
      },
      income: {
        tabs: '收入',
        totalTransaction: '交易总额（分）',
        avgArpu: 'ARPU均值',
        payOrderTotalAmount: '交易总额（分）',
        userArpu: '用户ARPU',
      },
      pay: {
        index: '支付订单用户构成',
        tabs: '付费设备',
        volumn: '总付费设备',
        payDeviceNew: '新增当日付费',
        payDeviceUnNewFirst: '非当日新增，当日首次付费',
        payDeviceUnNewUnFirst: '非当日新增，非当日首次付费',
      },
      payOrder: {
        tabs: '支付订单',
        payOrderCount: '支付订单数',
        payOrderRate: '订单完成率',
      },
      dayPayRate: {
        tabs: '首日付费率',
        avg: '首日付费率均值',
        newDevicePayFirstDay: '首日付费率',
      },
      weekPayRate: {
        tabs: '首周付费率',
        avg: '首周付费率均值',
        newDevicePayFirstWeek: '首周付费率',
      },
      monthPayRate: {
        tabs: '首月付费率',
        avg: '首月付费率均值',
        newDevicePayDayFirstMonth: '首月付费率',
      },
    },
    // 交易分析概览值
    transactionOverview: {
      title: '交易分析',
      launchuser: '活跃设备',
      order: '下单设备',
      pay: '支付订单数',
      conversion: '浏览-付费转化率',
      amount: '订单金额（分）',
      purchase: '复购率',
      explain: {
        launchUser: '所选日期内，至少使用过一次应用的设备数',
        placeOrder: '所选时段内生成过订单的独立设备数',
        payUser: '所选时段内支付订单的次数',
        viewPay: '支付订单人数/浏览商品人数',
        orderAmount: '所选时段内订单的金额合计值',
      },
    },
    addUserGroup: {
      add: '新建用户分群',
      edit: '编辑用户分群',
      groupName: '用户群名称',
      placeholder: '请输入用户群名称（20字符以内）',
      explain: '说明：系统会自动为当前所选平台各创建一个用户群',
      verifyDate: '样本时间范围变动可能会导致所考察的行为时间失效，请仔细检查',
      groupRange: '用户范围',
      nameConflict: '用户群名称已存在，请重新命名',
      exprConflict: '所选的条件组合已存在，请修改分群条件',
      addSuccess: '新建成功',
      editSuccess: '编辑成功',
      recover: '恢复',
      userRange: [{
        label: '新增用户',
        value: 'newuser',
      }, {
        label: '活跃用户',
        value: 'launchuser',
      }],
      dateType: [{
        label: '固定日期',
        value: 'fixed',
      }, {
        label: '滚动日期',
        value: 'roll',
      }],
      DateRange: [{
        label: '最近7天',
        value: 'week',
      }, {
        label: '最近30天',
        value: 'month',
      }],
      userAttrSel: {
        placeholder: '请添加用户属性',
        origin: '来源和属性',
        originItem: [{
          label: '初始渠道来源',
          placeholder: '全部渠道',
        }, {
          label: '国家及地区',
          placeholder: '全部国家及地区',
        }, {
          label: '运营商',
          placeholder: '全部运营商',
        }],
        mobile: '设备属性',
        mobileItem: [{
          label: '设备机型',
          placeholder: '全部机型',
        }, {
          label: '操作系统',
          placeholder: '全部操作系统',
        }],
      },
      userAttribute: {
        title: '用户属性',
        selected: '请选择',
        all: '所有',
        country: '国家及地区',
        allCountry: '全部国家及地区',
        mobile: '设备机型',
        allMobile: '全部机型',
        os: '操作系统',
        allOs: '全部操作系统',
        carrier: '运营商',
        allCarrier: '全部运营商',
        channel: '初始渠道',
        allChannel: '全部渠道',
      },
    },
    // 创建用户分群的用户行为
    userBehavior: {
      behavior: '用户行为',
      addPlaceholder: '请添加用户行为',
      startTimes: {
        title: '启动次数',
        unit: '次',
        totalStartTimes: '启动总次数',
        dailyStartAvg: '单日启动次数均值',
        dailyStartMin: '单日启动次数最小值',
        dailyStartMax: '单日启动次数最大值',
      },
      userTimes: {
        title: '使用时长',
        unit: 's',
        userTimes: '使用总时长',
      },
      launch_info: {
        title: '活跃情况',
        unit: '天',
        launchDays: '使用天数',
        userTrigger: '期间用户至少启动过1次应用',
      },
      lostDays: {
        title: '流失情况',
        unit: '天',
        info: {
          a: '截止目前，连续',
          b: '天及以上未使用应用',
        },
      },
      customevent: {
        title: '事件',
      },
      page_view: {
        title: '页面',
      },
    },
    userGroupEvent: {
      userTrigger: '期间用户至少1次触发',
      choose: '请选择事件',
      allEvents: '所有标准事件',
      between: '中',
      difEvents: '个不同事件',
      addLabel: '添加Label',
      label: '事件Label',
      noLabel: '没有可添加的label',
      addBtn: '添加条件',
      noData: '无匹配数据',
      loading: '加载中',
      chooseDate: '选择日期',
      dateLt30: '选择时间跨度不能超过30天',
      tooEarly: '请选择新增日期及之后的日期进行分析',
      repeatBehavior: '筛选条件重复，请重新选择行为或时间',
      choiceTip: '请补全筛选条件',
    },
    userGroupPage: {
      userTrigger: '期间用户至少访问过1次该页面: ',
      choose: '请选择页面',
    },
    // 小程序场景分析
    sceneAnalysis: {
      title: '场景分析',
      overview: {
        totalTimes: '总打开次数',
        topScene: 'No.1场景及贡献打开次数比例',
      },
      sceneDis: {
        tabs: '场景分布',
        legendNote: '打开小程序的Top10场景',
        unit: '次',
      },
      firstSceneDis: {
        tabs: '首次打开场景分布',
        legendNote: '首次打开小程序的Top10场景',
      },
      other: '其他',
      disDetail: '场景分布详情',
      totalVisit: '总打开次数',
      tableColumn: {
        sceneID: '场景值ID',
        sceneDes: '场景描述',
        //新增 访问次数
        pageAccessTimes: '访问次数',
        //访问次数-->打开次数
        visitTimes: '打开次数',
        dayVisitTimes: '日均打开次数',
        // 访问设备数 --> 打开用户数
        visitDev: '打开用户数',
        // 每设备访问次数 --> 人均打开次数
        devVisitTimes: '人均打开次数',
        // 新增设备数 --> 新增用户数
        newDev: '新增用户数',
        operate: '操作',
      },
      sceneList: '场景分析',
      explain: {
        title: '数据指标说明',
        totalVisit: '在所选时间段内，通过所有场景开始使用小程序的总次数。',
        noOneSceneAndRatio: '在所选时间段内，通过所有场景开始使用小程序的总次数中占比最高的场景及其占比。',
        sceneID: '微信小程序提供的使用场景ID，用于区分用户使用小程序时的不同场景。',
        sceneDes: '每个场景ID对应的场景说明。',
        //访问次数-->打开次数
        visitNum: '在所选时间段内，通过该场景打开小程序总次数。用户从打开小程序到主动关闭或超时退出小程序的过程，计为一次。',
        //新增访问次数
        pageAccessNum: '在所选时间段内，通过该场景访问小程序页面的总次数。多个页面之间跳转、同一页面的重复访问计为多次访问。',
        aveVisitNum: '在所选时间段内，通过所选场景开始使用小程序次数的每日均值。',
        visitDev: '在所选时间段内，通过该场景打开小程序页面的总用户数，同一用户多次打开不重复计。',
        visitDevNum: '在所选时间段内，通过所选场景开始使用小程序的每用户次数均值。',
        newDev: '在所选时间段内，通过该场景首次打开小程序页面的用户数，同一用户多次打开不重复计。',
        operate: '操作',
        ratio: '在所选时间段内，通过所选场景开始使用小程序的总次数占所有访问次数的比例。',
      },
      error: '场景数据请求失败',
    },
    // 小程序场景详情
    sceneDetail: {
      overview: {
        pageAccessTimes: '访问次数',
        visitTimes: '打开次数',
        visitDev: '打开用户数',
        newDev: '新增用户数',
        per: '占总场景（次数）比例',
      },
      trend: '趋势：',
      detail: '详情：',
      pageAccessTimes: {
        tabs: '访问次数',
        totalTimes: '总访问次数',
        dayAvgTimes: '日均访问次数',
      },
      visitTimes: {
        tabs: '打开次数',
        totalTimes: '总打开次数',
        dayAvgTimes: '日均打开次数',
      },
      visitDev: {
        tabs: '打开用户数',
        totalDev: '总打开用户数(排重)',
        dayAvgDev: '日均打开用户数',
      },
      newDev: {
        tabs: '新增用户数',
        totalNewDev: '总新增用户数',
        dayAvgNewDev: '日均新增用户数',
      },
      tableColumn: {
        date: '日期',
        pageAccessTimes: '访问次数',
        visitTimes: '打开次数',
        visitDev: '打开用户数',
        visitPerDev: '人均打开次数',
        newDev: '新增用户数',
      },
    },
    // 分享及传播
    shareDiss: {
      title: '分享及传播',
      overview: {
        shareAmt: '分享次数',
        shareDeviceAmt: '分享用户数',
        shareLinkClickAmt: '点击分享Link次数',
        newShareDeviceAmt: '新增用户数',
        linkOfAll: 'link点击占总打开次数比例',
        scenePro: '占总场景（次数）比例',
        shareUser: '分享用户数',
        shareAvg: '日均分享点击比',
        shareTip: '分享点击比',
      },
      trend: '分享趋势',
      date: '日期',
      shareAmt: {
        tabs: '分享次数',
        allCount: '总分享次数',
        dayCount: '日均分享次数',
      },
      shareDeviceAmt: {
        tabs: '分享用户数',
        allCount: '总分享用户数（排重）',
        dayCount: '日均分享用户数',
      },
      shareLinkClickAmt: {
        tabs: '点击分享Link次数',
        allCount: '总Link点击次数',
        dayCount: '日均Link点击次数',
      },
      newShareDeviceAmt: {
        tabs: '新增用户数',
        allCount: '总新增用户数',
        dayCount: '日均新增用户数',
      },
      shareTip: {
        tabs: '分享点击比',
        dayCount: '日均分享点击比',
      },
      page: '页面',
      pageShare: '页面分享分析',
      pageName: '页面名称',
      shareLinkClickDeviceAmt: '点击分享Link用户数',
      shareTipPro: '分享点击比',
      opreation: '操作',
      shareTop: '分享趋势详情',
      sharePage: '分享页面',
      userName: '用户昵称',
      headImg: '头像',
      explain: [{
        title: '分享次数',
        content: '在所选时间段内，完成分享的次数。',
      }, {
        title: '分享用户数',
        content: '在所选时间段内，完成分享的用户数。',
      }, {
        title: '点击分享Link次数',
        content: '在所选时间段内，点击分享Link并开始使用小程序的次数。',
      },
      {
        title: '点击分享Link用户数',
        content: '在所选时间段内，点击分享Link并开始使用小程序的用户数。',
      },
      {
        title: '分享点击比',
        content: '在所选时间段内，点击分享Link次数与分享次数的比值。',
      },
        // {
        //   title: '新增设备数',
        //   content: '在所选时间段内，通过点击分析Link开始使用小程序的用户中首次使用小程序的用户数',
        // }
      ],
      newUserExplain: {
        title: '新增用户数',
        content: '所选日期内通过点击分享Link带来的首次访问小程序的用户数。',
      },
      linkOfAllExplain: {
        title: 'link点击占总打开次数比例',
        content: '所选日期内通过分享场景访问小程序的次数占同期总访问次数的比例。',
      },
      explainAvgShareTipPro: '在所选时间段内，点击分享Link次数与分享次数比值的每日均值。',
    },
    // 扫码分析
    scanAnalysis: {
      title: '扫码分析',
      overview: {
        scanTimes: '扫码次数',
        scanDevs: '扫码用户数',
        newDevs: '新增用户数',
        per: '占总场景（次数）比例',
      },
      scanTrend: '扫码趋势',
      scanDetail: '扫码列表',
      createCode: '增加二维码',
      date: '日期',
      scanTimes: {
        tabs: '扫码次数',
        totalTimes: '总扫码次数',
        dayAvgTimes: '日均扫码次数',
      },
      scanDevs: {
        tabs: '扫码用户数',
        totalDev: '总扫码用户数(排重)',
        dayAvgDev: '日均扫码用户数',
      },
      newDevs: {
        tabs: '新增用户数',
        totalNewDev: '总新增用户数',
        dayAvgNewDev: '日均新增用户数',
      },
      tableColumn: {
        codeName: '二维码名称',
        pagePath: '页面路径',
        codeType: '类型',
        scanTimes: '扫码次数',
        avgScanTimes: '日均扫码次数',
        scanDevs: '扫码用户数',
        scanTimesPerDev: '人均扫码次数',
        newDevs: '新增用户数',
        operate: '操作',
      },
      qcodeType: {
        qcode: '二维码',
        mini: '小程序码',
      },
      explain: {
        scanTimes: '在所选时间段内，通过扫码所包含的场景开始使用小程序的次数。',
        scanDevs: '在所选时间段内，通过扫码所包含的场景开始使用小程序的用户数。',
        newDevs: '在所选时间段内，通过扫码所包含的场景开始使用小程序的用户中首次使用小程序的用户数。',
        ratio: '在所选时间段内，通过扫码所包含的场景开始使用小程序的总次数占所有访问次数的比例。',
      },
      error: '扫码数据请求失败',
    },
    // 扫码详情
    scanDetail: {
      qcode: '二维码：',
      overview: {
        scanTimes: '扫码次数',
        scanDevs: '扫码用户数',
        newDevs: '新增用户数',
        per: '占总场景（次数）比例',
      },
      trend: '趋势',
      detail: '详情',
      tableColumn: {
        date: '日期',
        scanTimes: '扫码次数',
        scanDevs: '扫码用户数',
        scanTimesPerDev: '人均扫码次数',
        newDevs: '新增用户数',
      },
    },
    // 二维码管理
    qrcodeManage: {
      title: '二维码管理',
      createCode: '创建二维码',
      batchCode: '批量创建二维码',
      delete: '删除',
      delModal: '是否确定删除所选二维码',
      tablePoptip: {
        head: '二维码分类及说明',
        fisrtLine: '目前小程序官方提供3种不同的二维码，分别是小程序码（A类）、小程序码（B类）和小程序二维码（C类）。',
        explainValue: [
          {
            title: '小程序码（A类）',
            explain: '适用于需要的码数量较少的业务场景。永久有效。用户扫描改码进入小程序后，将直接进入页面路径Path对应的页面。',
          }, {
            title: '小程序码（B类）',
            explain: '适用于需要的码数量较多，或仅临时使用的业务场景。永久有效。数量暂无限制。用户扫描该码进入小程序后，将统一打开首页，开发者需在首页根据获取的码中scene字段的值，在做处理逻辑。',
          }, {
            title: '小程序二维码（C类）',
            explain: '适用于需要的码数量较少的业务场景。用户扫描该码进入小程序后，将直接进入页面路径Path对应的页面。',
          },
        ],
        lastLine: '其中小程序码（A类）和小程序二维码合计总数量不超过100,000个，需谨慎使用',
      },
      table: {
        qcodeNm: '二维码名称',
        qcodeId: '二维码ID',
        appId: 'APP ID',
        qcodePath: '页面路径',
        tdChannelId: '渠道',
        qcodeParams: '参数',
        qcodeType: '样式',
        createTime: '创建时间',
        operation: '操作',
        qcodeType1: '二维码',
        qcodeType2: '小程序码',
        null: '无',
      },
      // 创建二维码
      codeModal: {
        title: '二维码',
        downCode: '下载二维码',
        code500: '请求失败，请重试',
        code40001: 'App Secret错误或App Secret不属于当前公众号，请确认App Secret的正确性！',
        code40002: '请确保grant_type字段值为client_credential！',
        code40013: 'App ID不合法，请重新输入',
        code40125: 'App Secret无效，请确认后重新输入',
        code40164: '调用接口的IP地址不在白名单中，请在接口IP白名单中进行设置',
        code40165: '该二维码信息已存在！',
        code40166: '获取生成微信二维码的token失败！',
        step1: {
          step: '第1步',
          headerText: '填写关键信息',
          certain: '创建二维码',
          cancel: '取消',
        },
        step2: {
          step: '第2步',
          headerText: '查看二维码信息',
          certain: '确定',
          cancel: '关闭',
        },
        step3: {
          step: '',
          headerText: '修改二维码信息',
          certain: '保存',
          cancel: '关闭',
        },
        codeName: {
          title: '二维码名称',
          placeholder: '最多支持128个字符，可包含中文、英文、数字。',
        },
        appId: {
          title: '小程序ID',
          placeholder: '微信平台分配的微信小程序ID',
        },
        appSecret: {
          title: '小程序密钥',
          placeholder: '微信平台分配的微信小程序密钥',
        },
        pageRoute: {
          title: '目标页面路径',
          placeholder: '小程序页面路径，如pages/index/index。含参数在内，最多支持128 字节',
          popTip: {
            content: '用户扫码所创建的二维码后，直接定向打开该路径所指向的页面。',
          },
        },
        // 表单验证提示语
        warning: {
          appIdIsNull: '小程序ID不能为空',
          secretIsNull: '小程序密钥不能为空',
          codeIsNull: '二维码名称不能为空',
          codeIsExisted: '二维码名称已存在，请重新输入',
          codeError: '请输入中文、英文、数字',
          channelIsNull: 'TDChannelID不能为空',
          channelError: '请输入英文、数字，不支持空格及其他特殊字符',
          qcodePathIsNull: '目标页面路径不能为空',
          qcodePathFirstLimt: '首字符不可为"/"',
          qcodeError: '请输入英文、数字，不支持空格及其他特殊字符',
          paramsIsNull: '参数不能为空',
          // paramsIsChannel: '参数不可为TDChannelID',
          paramsError: '请输入t及TDChannelID以外的字母或字母组合',
          paramsRepeat: '参数不可重复',
          valueIsNull: '参数值不能为空',
          valueError: '请输入字母、数字',
          wordLimit: '目标页面路径、TDChannelID、自定义参数字符长度总和已超出128，请酌情删减',
        },
        type: {
          title: '样式',
        },
        isChannel: {
          title: '是否作为渠道',
          placeholder: '渠道ID，只支持数字、英文。最多64个字符',
          yes: '是',
          no: '否',
          popTip: {
            content: '如果将二维码作为渠道，则将该值直接归入该渠道ID，否则则记为微信回传的场景值不做细分。渠道默认的参数值为“TDChannelID”，在使用其他第三方工具生成二维码时使用该字段作为参数，该二维码也会记作独立渠道。',
          },
        },
        params: {
          title1: '参数',
          title2: '参数值',
          buttonText: '增加自定义参数',
          placeholder1: '字母。如：city',
          placeholder2: '字母或数字。如：zhang',
        },
      },
      // 批量创建二维码
      batchCodeModal: {
        title: '批量创建二维码',
        submit: '提交',
        cancel: '取消',
        createMethod: '创建方式',
        editOnline: '在线批量编辑',
        templateUpload: '按模板批量上传',
        downtemplate: '下载模板',
        uploadList: '上传二维码信息列表',
        down: '下载',
        dragValue: '点击或将文件拖拽到这里上传',
        pendingUpload: '待上传文件：',
        supportFile: '支持扩展名：.xls .csv .xlsx',
      },
    },
    // 用户质量评估
    quality: {
      common: {
        loading: '加载中...',
        nodata: '暂无数据',
        search: '请输入关键词检索...',
        page: '每页显示',
        pre: '条',
        other: '其他',
        time: '时间',
        pagesize: '条/页',
      },
      tabs: {
        new: '新增用户质量评估',
      },
      date: {
        day7: '近7日',
        day30: '近30日',
      },
      titles: {
        title: '用户质量评估',
        overview: '用户质量评估概览',
        silent: '静默用户',
        contrast: '分渠道质量对比',
        pie: '概览',
        trend: '趋势',
        keepuser: '留存对比',
      },
      user: {
        all: '总用户',
        normal: '正常用户',
        suspicious: '可疑用户',
        silent: '静默用户',
        silentRate: '静默用户占比',
        normalRate: '正常用户占比',
        suspiciousRate: '可疑用户占比',
        rate: '占比',
        des: {
          all: '所选时间段内，总新增用户',
          normal: '总用户中，没有被识别为可疑用户的用户',
          suspicious: '总用户中，设备信息不一致、IP离散度异常或依据SDK姿态数据分析出姿态分布异常的设备，确定为可疑用户。',
          silent: '静默设备，特指打开SDK中反作弊开关，但是采集到的姿态数据不符合正常的用户行为姿态分布的设备。这部分数据作为异常设备判断条件的一种，可以提高异常设备识别的精度。',
          silent_rate: '总用户中，静默用户所占的比例',
        }
      },
      metric: {
        nextday: '次日留存率',
        day7: '7日留存率',
        day30: '30日留存率',
      },
      table: {
        date: '日期',
        all_rate: '占总用户比例',
        sus_rate: '占可疑用户比例',
        all_nextDay_rate: '总用户次日留存率',
        nor_nextDay_rate: '正常用户次日留存率',
        sus_nextDay_rate: '可以用户次日留存率',
        sil_nextDay_rate: '静默用户次日留存率',
        channel: '渠道名称',
      }
    },
    // 日志导出
    exportLog: {

    }
  },
  'en-US': {
    message: {
      hello: 'Hello'
    },
    demo: {
      info1: 'You are viewing DEMO data now, would you like to have your own product data?',
      info2: 'You are viewing DEMO data now, ready to read your product data',
      link: 'View your data now',
      login: 'Register now and log in',
    },
    guide: {
      start: 'Choose an application and begin your data journey',
      iknow: 'I see',
      next: 'Next',
      skip: 'Skip',
      quality: 'Using black tech like gesture detection to identify exception device',
      portrait: 'Learn more about user through gender, age and preference of using application',
      exploration: 'Check version distribution and region distribution here now',
      analysis: 'Learn analysis function here',
      push: 'Learn marketing function here',
      helper: 'Learn error report,authentication here',
      manage: 'Learn settings and event management here',
      auth: 'Click here to invite friends to follow app performance',
    },
    onlineService: {
      online: 'online',
      service: 'service',
    },
    common: {
      loading: 'Loading...',
      nodata: 'Not found any data',
      fail: 'Operation Failed!',
      errorTip: 'Failed to get data,please try again',
      delFailed: 'Failed to delete,please try again',
      updateFailed: 'Failed to update,please try again',
      input: 'Please Enter...',
      hide: 'Hide',
      show: 'Show',
      copy: 'Copy',
      suc: 'Successfully!',
      send: 'Send',
      contain: 'Include',
      nocontain: 'Exclude',
      yes: 'Yes',
      no: 'No',
      certain: 'Ensure',
      cancel: 'Cancel',
      save: 'Save',
      noSave: 'You have unsaved changes!',
      search: 'Search',
      isLeave: 'If you leave before saving, your changes will be lost.Are you sure you want to leave this page?',
      channelNameLength: 'The channel name should be less than 16 characters Chinese, letter, number, underline, please re-enter.',
    },
    filter: {
      week: 'Last week',
      month: 'Last month',
      threeMonth: 'Last 3 months',
      halfYear: 'Last half year',
      oneYear: 'Last year',
      conditions: 'Filter',
      choose: 'Choose ',
      partner: 'Channels',
      usergroup: 'Segments',
      version: 'Version',
      clear: 'Clear',
      confirm: 'Confirm',
      cancel: 'Cancel',
      search: 'Search',
      all: 'All',
      err: 'One Platform At Least！',
      supportUserGroup: 'Unable to select this property',
    },
    header: {
      analytics: 'Analytics',
      push: 'TDPush',
      market: 'Market Insight',
      helper: 'Developer Tools',
      manage: 'Admin',
      lang: '中文',
      setting: 'Setting',
      signout: 'Sign Out',
      center: 'Account Center',
      back: 'Back to Old',
      accountTitle: 'Invite more colleagues to share data and analytics',
      notice: 'Notifications',
      grant: 'Permissions',
      code: {
        app: 'TalkingData App',
        down: 'Download',
        service: 'Official WeChat',
        focus: 'Follow',
      },
    },
    appInfo: {
      title: 'Notifications',
      usergroupModal: {
        a: 'Unable to select this function, if you need, go to Explorer',
        b: 'Unable to select this property',
      },
    },
    overview: {
      title: 'Application Overview',
      cumulative: 'Total Devices',
      suspicious: 'Suspicious Devices (%)',
      week: '7 Days Active Devices',
      month: '30 Days Active Devices',
      single: 'Last 7 Days Daily Using Duration',
      explain: {
        a: 'Total amount of devices from the day when TalkingDataApp Analytics SDK get intergrated to a certain statistics day',
        b: 'The amount and percentage of devices marked as suspect devices of new devices in last 30 days',
        c: 'Devices used at least once in last 7 days(exclude query day)',
        d: 'Devices used at least once in last 30 days(exclude query day)',
        e: 'Avg. usage time of one device per day',
      },
    },
    nav: {
      overview: {
        title: 'Data Overview',
        app: 'Application Overview',
        data: 'Realtime',
        trend: 'Usage Trend',
        channel: 'Channel Data',
        uninstall: 'Uninstall Data',
        keep: 'Retention',
        scene: 'Scene Analysis',
        scan: 'Scan Analysis',
        share: 'Forword Analytics',
        quality: 'User Quality',
      },
      table: {
        title: 'Tables',
        custom: 'Custom Table Name',
        create: 'Create New DashBoard',
      },
      user: {
        title: 'Audience',
        feature: 'User Characteristics',
        portrait: 'User Portrait',
        group: 'Segment',
        detail: 'Individual',
        mcDrainage: 'Smart Marketing Cloud',
      },
      behavior: {
        title: 'User Behavior',
        page: 'Page View',
        event: 'Custom Events',
        funnel: 'Funnel',
        flexible: 'Smart Code',
      },
      exploration: {
        title: 'Explorer',
        eventTitle: 'Event Explorer',
      },
      business: {
        title: 'E-Business Analytics',
        transaction: 'Transcation Analytics',
        purchase: 'Repeated Purchase',
      },
      account: {
        title: 'Permissions',
      },
      push: {
        push: 'TDPush',
        options: 'TDPush Settings',
      },
      err: {
        report: 'Error Report',
        analytics: 'Error Analytics',
        list: 'Error List',
        detail: 'Error Details',
      },
      exportLog: '日志导出',
      exportData: '日志导出',
      eauth: {
        eauth: 'eAuth',
        overview: 'eAuth Overview',
        list: 'eAuth Detail',
        message: 'eAuth Settings',
        warning: 'Alerts',
      },
      manage: {
        title: 'Admin',
        info: 'Application Info',
        channel: 'Channel Management',
        event: 'Event Management',
        warn: 'Alerts',
        edition: 'Version Management',
        data: 'Data APIs',
        note: 'Annotations',
        qrcode: 'QR Code Management',
        subscription: '订阅服务',
      },
    },
    productCenter: {
      title: 'Application Center',
      title1: 'Management Center',
      create: 'Create an App',
      productname: 'App Name',
      platform: 'Platform',
      miniAppID: 'Mini Program ID',
      miniAppSecret: 'Mini Program Secret',
      totaluser: 'Total Devices',
      today_new: 'New Devices (Today)',
      yes_new: 'New Devices (Yesterday)',
      today_active: 'Active Devices (Today)',
      yes_active: 'Active Devices (Yesterday)',
      operation: 'Operations',
      hoverInfo1: 'You are the owner of this app',
      hoverInfo2: 'You are authorized to view this app data',
      type: 'Category',
      game: 'Category Of Game',
      icon: 'App Icon',
      input: 'Please Enter',
      choose: 'Please Choose',
      upload: 'Upload Icon',
      integration: 'Get SDK and App ID',
      download: 'Download SDK',
      delInfo: {
        a: 'All data of the app will be deleted when you delete the app. Be careful!',
        b: 'Are you sure you want to delete this app?',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      delSuc: 'Success!',
      email: 'The Email of the invitee',
      finish: 'Finished',
      doc: {
        a: {
          title: 'Tips',
          content: [
            'Just build a cross-platform app, all platforms using the same App ID,  then you can read aggregate data and data of a single platform by selecting platformthe.',
            'Carefully select the category of app, it will be conducive to view data accuracy subsequent reports of the same type game industry benchmark values.',
            'Uploading the iCon of the app.',
          ],
        },
        b: {
          title: 'Invite colleague to integrate the SDK',
          content: 'You can send emails to your colleague to integrate the SDK and debug。The invitee will get the information such as App ID to integrate and debug, without permissions to read data of the app.'
        },
        c: {
          title: 'Integration Guide',
        },
      },
      errInfo: {
        a: 'App name is needed',
        b: 'App name should be less than 50 characters Chinese, letter, number, underline.',
        c: 'Please select a platform for the app.',
        d: 'Please select a category for the app.',
        e: 'Please select a category for the game.',
        f: 'The Email is wrong.',
        g: 'The format is wrong',
        h: 'The file have exceeded the size limit.',
        i: 'It must be Jpg or png.',
        j: 'The file have exceeded the size limit.',
        k: 'Reinput product name as the name has existed',
        l: 'fail to create product',
        m: ' Less than 64 letters',
        n: ' is needed',
      },
      miniAppError: {
        a: 'The Mini program ID or Mini program secret error.',
        b: 'The system is busy, please try again later.',
        c: ' should be less than 64 characters letter,number,please re-enter.',
      },
      getMiniAppID: 'How to get the Mini program ID',
      getMiniAppSecret: 'How to get the Mini program Secret',
      sendFinish: 'The email has been send.',
    },
    productType: {
      key19: 'Books',
      key0: 'Games',
      key20: 'Entertainment',
      key10: 'Social Networking',
      key17: 'Shopping & E-business',
      key11: 'Lifestyle',
      key16: 'Tools',
      key21: 'Utility',
      key22: 'Weather',
      key23: 'Sport',
      key24: 'Music',
      key25: 'News',
      key26: 'Magazines',
      key27: 'Reference',
      key28: 'Navigation',
      key29: 'Finance',
      key12: 'Health &Fitness',
      key30: 'Education',
      key31: 'Travel',
      key32: 'Business',
      key9: 'Photo & Video',
      key33: 'Medical',
      key13: 'Wallpaper',
      key14: 'Widget',
      key8: 'Other',
      key3: 'Games-Role Playing',
      key34: 'Games-Simulation',
      key4: 'Games-Sports',
      key7: 'Games-Strategy',
      key2: 'Games-Puzzle',
      key6: 'Games-Action',
      key35: 'Games-Adventure',
      key1: 'Games-Arcade',
      key5: 'Games-Board',
      key36: 'Games-Card',
      key37: 'Games-Casino',
      key38: 'Games-Dice',
      key39: 'Games-Educational',
      key40: 'Games-Family',
      key18: 'Games-Kids',
      key41: 'Games-Music',
      key42: 'Games-Racing',
      key43: 'Games-Trivia',
      key44: 'Games-Word',
    },
    channel: {
      overview: {
        trend: 'Trend of Channel Data',
        top5: 'TOP5 Channel',
        show: 'Overview',
        details: 'Channel Details',
        setInfo: 'Channel Management',
      },
      tableview: {
        name: 'Channel name',
        platform: 'Platform',
        set: 'Operations',
        number: {
          name: 'Quantity Metrics',
          newusertoday: 'New Devices today',
          newuseryesterday: 'New Devices yesterday',
          newuser: 'New Devices',
          launchuser: 'Active Devices',
          launchuserAverage: 'Avg. Active Devices',
          startup: 'Sessions',
          totaluser: 'Total Devices',
        },
        quality: {
          name: 'Quality Metrics',
          startuptoday: 'Start today',
          launchtoday: 'Active today',
          launchyesterday: 'Active yesterday',
          launchuser: 'Active Devices',
          startup: 'Sessions',
          startupAverage: 'Avg. Sessions per Devices',
          onetime: 'Avg. Session Duration',
          onceuser: 'One Session Devices',
        },
        keep: {
          name: 'Retention Metrics',
          oneday: '1 day Retention Rate',
          week: '7 days Retention Rate',
          month: '30 days Retention Rate',
        },
      },
      index: {
        a: ': Amount of devices which download the app for the first time from selected channels at some specified date. One device only can be counted once when it download app for the first time otherwise the device can\'t be counted for installation repeatedly.',
        b: ': Amounts of device using app at least once from selected channels at some specified date(not limited to new added time).',
        c: ': Average amounts of device using app at least once everyday from selected channels at some specified date (not limited to new added time ).',
        d: ': Number of times of installation package opened from selected channels at some specificed date.',
        e: 'Total amount of devices from the day when TalkingDataApp Analytics SDK get intergrated from selected channels to a certain statistics day.',
        f: ': Average amounts of app usage at one device from selected channels at some specified date.',
        g: ': The amount and percentage of devices which are active only at installing day from selected channels at some specificed date.',
        h: ': Average time of app starting from selected channels at some specificed date.',
      },
    },
    singleChannel: {
      title: 'Channel Data',
      cumulative: 'Total Devices',
      weekadd: 'Weekly Growth Rate',
      monthadd: 'Monthly Growth Rate',
      weekactive: 'WAU Rate',
      monthactive: 'MAU Rate',
      single: 'Avg. Duration per Device',
      totalNumber: 'Sum.',
      averageNumber: 'Avg.',
      launchuserTotal: 'Active(unique users)',
      explain: {
        a: 'Total amount of devices from the day when TalkingDataApp Analytics SDK get intergrated to a certain statistics day',
        b: 'The extent of variation of newly added devices last week over newly added devices in the week ended with the day defined from selected channels.e.g if you want to check distribution performance from 2015-5-11 to 2015-5-13,weekly device growth = (newly added devices from the selected channel from 2015-5-7 to 2017-5-13/newly added devices from the same channel from 2015-4-30 to 2017-5-6)-1',
        c: 'The extent of variation of newly added devices last month over newly added devices in the month ended with the day defined(30 days a month) from selected channels.e.g if you want to check distribution performance from 2015-5-11 to 2015-5-13,monthly device growth = (newly added devices from the selected channel from 2015-4-14 to 2017-5-13/newly added devices from the same channel from 2015-3-15 to 2017-4-13)-1',
        d: 'The ratio of active devices to accumlated devices in the week ended with the day defined from selected channels.e.g if you want to check distribution performance from 2015-5-11 to 2015-5-13,weekly device growth = ( active devices from the selected channel from 2015-5-7 to 2017-5-13/accumlated devices from the same channel before 2017-5-13)-1 ',
        e: 'The ratio of active devices to accumlated devices in the month ended with the day defined from selected channels(30 days a month).e.g if you want to check distribution performance from 2015-5-11 to 2015-5-13,monthly device growth = (active devices from the selected channel from 2015-4-14 to 2017-5-13/accumlated devices from the same channel before 2017-5-13)-1 ',
        f: 'Average time of app usage on one device from selected channels at some specified date ',
      },
      index: {
        a: ': Amount of devices which download the app for the first time from selected channels at some specified date. One device only can be counted once when it download app for the first time otherwise the device can\'t be counted for installation repeatedly  ',
        b: ': Amounts of device using app at least once from selected channels at some specified date(not limited to new added time) ',
        c: ': Number of times of installation package opened from selected channels at some specificed date。',
      },
    },
    chartview: {
      distribution: 'Daypart',
      diff: 'Comparison',
      trend: 'Usage In 30 Days',
      details: 'Details',
      detailsinfo: '',
      newuser: {
        name: 'New Devices',
        today: 'Today',
        yesterday: 'Yesterday',
        watch: 'New WatchKit',
      },
      launchuser: {
        name: 'Active Devices',
        today: 'Today',
        yesterday: 'Yesterday',
        watch: 'Active WatchKit ',
        day: 'Daily Active Devices',
        week: 'Weekly Active Devices',
        month: 'Monthly Active Devices',
      },
      startup: {
        name: 'Sessions',
        average: 'Avg. Sesstions per Device',
        today: 'Today',
        yesterday: 'Yesterday',
      },
      startups: {
        name: 'Avg. Sesstions per Device',
        average: 'Avg. Sesstions per Device',
      },
      onceuser: {
        name: 'One Session Device Rate',
      },
      keepuser: {
        name: 'Retention Rate',
        oneday: '1 day Retention Rate',
        week: '7 days Retention Rate',
        month: '30 days Retention Rate',
      },
      onetime: {
        name: 'Avg. Duration per Device',
        onetime: 'Avg. Session Duration',
      },
      onetimes: {
        name: 'Avg. Session Duration',
        onetimes: 'Avg. Session Duration',
      },
      usetime: {
        name: 'Avg. Duration per Device',
        onetime: 'Avg. Session Duration',
      },
      table: {
        newuser: 'New Devices',
        newwatch: 'New WatchKit',
        launchuser: 'Active devices',
        launchwatch: 'Active WatchKit',
        startup: 'Sessions',
        onetime: 'Avg. Session Duration',
        average: 'Avg. Sessions per Devices',
        daylaunchuser: 'Daily Active Devices',
        week: 'Weekly Active Devices',
        month: 'Monthly Active Devices',
      },
      week: {
        week: 'Weekly Active Devices',
        name: 'Weekly Active Devices',
      },
      month: {
        month: 'Monthly Active Devices',
        name: 'Monthly Active Devices',
      },
      share: 'Sharing effect',
      channel: 'Distribution channel',
      yesterday: 'Yesterday',
      yTime: 'At this Duration yesterday',
      today: 'Today',
      total: 'Sum.',
      average: 'Avg.',
      range: 'Daypart',
      indexTime: {
        a: ': Number of devices first installed per hour yesterday and today. One device can only be counted as a new device when first installed and devices installled repeatedly won\'t be counted again.',
        b: ': start-up time of application per hour yesterday and today.',
        c: ': Number of devices active devices per hour yesterday and today. Divided by hourly, the active devices is drained every hour, and the weight is not drained during different time periods.'
      },
      indexTrend: {
        a: ': Number of devices first installed in recent 30 days. One device can only be counted as a new device when first installed and devices installled repeatedly won\'t be counted again.',
        b: ': Number of devices opening app at least once per day in recent 30 days.',
        c: ': Number of sessions the app had been started per day in recent 30 days.',
        d: ': Avg. duration of one device using app in recent 30 days.',
        e: ': Avg.retention rate of new devices per day in recent 30 days.',
      },
    },
    userGroup: {
      more: 'Learn more',
      mcInfo: 'Finding target customers, acquiring potential customers, and insight into customer demographics. Let the TalkingData Smart Marketing Cloud help you to more accurately target your customers and more intelligent algorithms to find potential customers.',
      add: 'Add New Segment',
      name: 'Segments',
      type: 'Type',
      filter: 'Filter',
      state: 'State',
      init: 'Init...',
      stable: 'Stable',
      failed: 'Failed',
      time: 'Date',
      scale: 'User',
      operation: 'Operation',
      suc: 'Operation Succeeds！',
      delete: 'Delete',
      detail: 'Detail',
      range: 'DateRange',
      new: 'New ',
      active: 'Active ',
      user: 'Devices',
      is: 'is',
      region: 'Region',
      china: 'China',
      event: 'Event',
      do: 'do the event',
      model: 'Model',
      os: 'OS',
      carrier: 'Carrier',
      jailbreak: 'Jailbreak or not',
      crack: 'Crack or not',
      addevent: 'Add Event',
      nolimit: 'All',
      break1: 'Jailbreaked',
      break2: 'Unjailbreaked',
      crack1: 'With cracked app',
      crack2: 'Without cracked app',
      all: 'All ',
      choose: 'Choose ',
      selected: 'Selected ',
      des: 'Note: System would create segements for all selected platforms automatically',
      des1: 'Total ',
      des2: 'Devices',
      userExpression: {
        nodata: 'No filter',
        userType: 'User',
        userAttribute: 'User properties',
        userBehavior: 'User behavior',
        newuser: 'New user',
        launchuser: 'Active user',
        userAttributeItem: {
          user_region: 'Country and region',
          mobile_info: 'Model',
          os_info: 'OS',
          isp_info: 'Operator',
          partner_info: 'Channel',
        },
      },
      errInfo: {
        a: 'The name of segments is need.',
        b: 'The length of the name should be less than 64 charactors.',
      },
      delInfo: {
        a: 'The Segment won\'t be selected in \'Filter\' when it has been deleted. Setting a new segment with the same conditions when you want to observe them again.',
        b: 'Are you sure you want to delete this segment?',
      },
    },
    keepuser: {
      keep: 'Retention Ratio',
      newuserkeep: 'New Device Retention',
      activekeep: 'Active Device Retention',
      day: 'Daily',
      week: 'Weekly',
      month: 'Monthly',
      date: 'Date',
      user: 'Devices',
      average: 'Average',
      des: [{
        name: 'New Device Retention',
        doc: ': Rate of new devices still using app in selected dates.'
      }, {
        name: 'Active Device Retention',
        doc: ': Rate of active devices still using app in selected dates.'
      }, {
        name: '+N Days Retention',
        doc: ': Rate of new (or active) devices using app after N days. New (or active) devices using app after N days / new (or active) devives on one day. Unless stated, it usually refers to active rate of new device.'
      }, {
        name: '+N Weeks Retention',
        doc: ':  Rate of new(or active)devices using app after N weeks. New (or active) devices using app after N weeks / new (or active) devives on one day.'
      }, {
        name: '+N Months Retention',
        doc: ':  Rate of new(or active)devices using app after N weeks. New (or active) devices using app after N weeks / new (or active) devives on one day.'
      }, {
        name: 'Effetive Average',
        doc: ':  Judge the correctness of the future time in n weeks or months later, if not correct do not make it under consideration for calculation.'
      }],
    },
    trend: {
      title: 'Trend',
      table: 'Details',
      overview: {
        title: 'Usage Trend',
        newuser: 'New Devices',
        launchuser: 'Active Devices',
        launchpro: 'DAU/MAU',
        startup: 'Sessions',
        onetime: 'Avg. Session Duration',
        explain: {
          a: 'Number of devices first installled in selected dates. One device can only be counted as a new device when first installed and devices installled repeatedly won\'t be counted again.',
          b: 'Number of device using app at least once in selected dates',
          c: 'Avg.value of DAU/MAU in selected dates is an indicator for social games and online apps to evaluate device stickiness. When the value is close to 1, it means the device stickiness is high and when the value is below 0.2, it means the transmission and interaction of app is weak. DAU/MAU*30 is refered as avg.active days per month in the industry.',
          d: 'start-up time of app in selected dates',
          e: 'Avg.time of starting app a time in selected dates',
        }
      },
      newuser: {
        name: 'New Devices',
        total: 'Sum.',
        average: 'Avg.',
        'watch-total': 'Sum. New WatchKit',
        'watch-average': 'Avg. New WatchKit'
      },
      launchuser: {
        day: 'Daily Active Devices',
        week: 'Weekly Active Devices',
        month: 'Monthly Active Devices',
        total: 'Active Devices(unique users)',
        average: 'Avg. Active Devices',
        'watch-total': 'Active WatchKit',
        'watch-average': 'Avg. Active WatchKit'
      },
      startup: {
        name: 'Sessions',
        average: 'Avg. Sessions',
      },
      onetime: {
        name: 'Sessions Duration',
        average: 'Avg. Sessions Duration',
      },
      index: {
        a: ': Number of devices first installled in selected dates. One device can only be counted as a new device when first installed and devices installled repeatedly won\'t be counted again.',
        b: ': active device today.',
        c: ': Number of active device in recent week by the end of day (7 days including today).',
        d: ':Number of active device in recent month by the end of day (30 days including today).',
        e: ': Start-up time of app every day in selected dates.',
        f: ': Avg.time of starting app a time in selected dates.',
      }
    },
    uninstall: {
      describe: 'Uninstall Insight into net activations',
      freeOpen: 'Free to open, no more coding, really looking at the data',
      needApns: 'The pass requires the use of Apple\'s official push service APNS，',
      goSetting: 'please go to the settings.',
      onlyIOS: 'For ios platform applications only, click  more',
      stopUse: 'The general energy has been deactivated. If you need to open it, please contact the manual service: 400-870-1230',
      failOpen: ' Failed, you can contact the manual service to resolve it.',
      opening: 'Send...',
      successInfo: 'The email has been sent, please wait for the review. Analytical data can be viewed 24 hours after opening.',
      expiredWarning: 'Apple\'s official push service certificate will be expired on ',
      affectUse: 'which will affect the uninstall analysis function. Please go to the update as soon as possible，',
      willExpired: 'will expired',
      haveExpired: 'have expired',
      goToUpdate: 'Please go to the update as soon as possible.',
      title: 'Uninstall',
      date: 'Date',
      applyOpen: 'Open',
      newuserDevice: 'New Device',
      uninstallDevice: 'Uninstalls',
      uninstallTip: 'The device that uninstalled the App was detected during the selected time period. The detection delay was within 48 hours.',
      pureAddDevice: 'Net activations',
      pureAddTip: 'New device - Uninstall device during the selected time period.',
      newUserAndUninstall: 'New Device and Net activations',
      dataRange: 'Data Range：for ios platform applications only',
      newuserAvg: 'New Device Avg',
      uninstallAvg: 'Uninstall Device Avg',
      pureAddAvg: 'Net Activations Avg',
    },
    pageaccess: {
      tab1: 'Page View',
      tab2: 'User Path',
      checked: 'View',
      link: 'Next Step',
      table: {
        page: 'Page Name',
        name: 'Display Name',
        accessNum: 'Number of entrance pages',
        platform: 'Platform',
        userNum: 'Devices',
        pageFrequency: 'Page Vies（Times | Rate）',
        alltimepro: 'time Rate',
        stay: 'Avg. Duration per Page',
        leave: 'Exit Rate',
        trend: 'Next Step'
      },
      index: {
        a: 'Devices',
        b: 'Page Views',
        c: 'Page Views\' Rate',
        d: 'Duration Rate',
        e: 'Avg. Duration per Page',
        f: 'Exit Rate',
        g: 'Note',
        h: 'Number of entrance pages',
      },
      explain: {
        a: 'Device on page in selected duration.',
        b: 'Page views on page in selected duartion.',
        c: 'The page views on this page accounts for all pages in selected duration.',
        d: 'The duration on this page accounts for all pages in selected duration.',
        e: 'Avg.duration on this page in selected dates.',
        f: 'Last viewed on page accounts for all visit on this page in selected duration.',
        g: 'To insure computing speed, we only offer the data on page in last year. For more info, please contact us.',
        h: 'The number of times the access page is accessed as a session in selected duration.',
      }
    },
    exploration: {
      title: 'Explorer',
      placeholder: 'Input the keyword, please',
      save: 'Save',
      create: 'Create',
      addmetric: 'Select the metrics',
      addDimension: 'Select the dimensions',
      prompt1: 'Select a metrics, please',
      prompt2: 'Select a dimension, please',
      prompt3: 'Input a name for these Query conditions，and save it',
      tip: {
        tip1: 'Success',
        tip2: 'Success',
        tip3: 'Success',
      },
      query: {
        metric1: 'Metrics',
        metric2: 'Metrics',
        metric3: 'Dimensions',
        querydata: 'Query',
      },
      explain: [{
        title: 'Total Decives',
        detail: 'Total amount of devices during the  selected time period.',
        key: 'totaluser',
      }, {
        title: 'New Devices',
        detail: 'Number of devices first installed in the selected time period.One device can only be counted as a new device when first installed and devices installled repeatedly won\'t be counted again.',
        key: 'newuser',
      }, {
        title: 'Uninstalls',
        detail: 'The device that uninstalled the App was detected during the selected time period. The detection delay was within 48 hours.For ios platform applications only.',
        key: 'uninstalluser',
      }, {
        title: 'Active Devices',
        detail: 'The devices which are used at least once in the selected time period.',
        key: 'launchuser',
      }, {
        title: 'Daily Active Devices',
        detail: 'Active device today.',
        key: 'daylaunchuser',
      }, {
        title: 'Weekly Active Devices',
        detail: 'Number of active device in recent week by the end of day (7 days including today).',
        key: 'weeklaunchuser',
      }, {
        title: 'Monthly Active Devices',
        detail: 'Number of active device in recent month by the end of day (30 days including today).',
        key: 'monthlaunchuser',
      }, {
        title: 'DAU/MAU',
        detail: 'active devices today accounts for active devices in 30 days .',
        key: 'DAU/MAU',
      }, {
        title: 'New Device Retention',
        detail: ' Rate of new devices still using app in selected dates.',
        key: 'keepuser',
      }, {
        title: 'Active Device Retention',
        detail: ' Rate of active devices still using app in selected dates.',
        key: 'keeplaunchuser',
      }, {
        title: 'One Session Devices',
        detail: 'Take users newly added within one year and more than 7 days (excluding the day of the query),Number of users using app only when app got installed and rate the those users .',
      }, {
        title: 'Churn Users',
        detail: 'Until some day, the active users who continuatively did not use the app for 7/14/30 days, then the user can be regarded as a Churn user',
        key: 'loseuser',
      }, {
        title: 'Using Days of Churn',
        detail: 'Number of using days of devices subject to the 7/14/30 lossing standard in selected duration.',
      }, {
        title: 'Sessions of Churn',
        detail: 'Number of using times of devices subject to the 7/14/30 lossing standard in selected duration.',
      }, {
        title: 'Duration of Churn',
        detail: 'Time of usage of devices subject to the 7/14/30 lossing standard in selected duration.',
      }, {
        title: 'Returning Devices',
        detail: 'Devices subject to the 7/14/30 lossing standard reuse app one day can be seen as returning devices.Returning devices can reflect effect of waking sleeping devices. E.g. if a device don’t use app for 7 days from 2013-11-6 to 2013-11-12 and the devcie reopen app on 2013-11-13, the device will be seen as a returning device.',
        key: 'keeplose',
      }, {
        title: 'Returning Devices',
        detail: 'Number of devices still using app in the selected time period (excluding the day of the query).Due to the metrics limitation, did not compute the data during the last 8 days(including the day of the query)',
        key: 'retetionuser',
      }, {
        title: 'Returning Devices in Last 7 days',
        detail: 'Number of devices still using app in last 7 days (excluding the day of the query). E.g. if you check returning devices of 2013-11-11 on 2013-11-20, it refers to devices newly added on 2013-11-20 are still using app from 2013-11-13 to 2013-11-19.',
        key: 'retetionuser_retetion7',
      }, {
        title: 'Returning Rate in Last 7 days',
        detail: 'Returning devices in last 7 days/ new devices one day.',
        key: 'retetionuser_retetionrate7',
      }, {
        title: 'Update Devices',
        detail: 'Devices upgrading to current version one day.',
        key: 'versionupdate',
      }, {
        title: 'Sessions',
        detail: 'Start-up related metrics.',
        key: 'startup',
      }, {
        title: 'Sessions',
        detail: 'The total start-up time of app in selected time duration.',
        key: 'startup_total',
      }, {
        title: 'Avg. Sessions per Devices',
        detail: 'Avg. start-up time of app per day.',
        key: 'startup_average',
      }, {
        title: 'Sessions Distribution',
        detail: 'Distribution of start-up time of one device in selected duration',
      }, {
        title: 'Duration per Session',
        detail: 'Usage time related metrics',
        key: 'usetime',
      }, {
        title: 'Avg. Duration per Session',
        detail: 'Avg.usage time of app in selected duration',
        key: 'usetime_single',
      }, {
        title: 'Avg. Duration per Device',
        detail: 'Avg.app usage time of one device in selected duration',
        key: 'usetime_average',
      }, {
        title: 'Session Duration Distribution',
        detail: 'Distribtion of app usage time in selected duration',
        key: 'usetime_singledistribute',
      }, {
        title: 'Session Interval',
        detail: 'Differences of start-up time of two adjacent sessions',
        key: 'intervallevel',
      }, {
        title: 'Startup Session Interval',
        detail: 'Differences of start-up time of two adjacent sessions',
        key: 'startup_interval',
      }, {
        title: 'Ths First Session',
        detail: 'New device first uses app',
      }, {
        title: 'Jailbreakedcreate',
        detail: 'Jailbreaked devices related metrics',
        key: 'jailbrokencreate',
      }, {
        title: 'Jailbreaked Devices',
        detail: 'Number of jailbreaked devices of new devices in selected duration',
        key: 'jailbroken',
      }, {
        title: 'Unjailbreaked Devices',
        detail: 'Number of unjailbreaked devices of new devices in selected duration',
        key: 'nojailbroken',
      }, {
        title: 'Jailbreaked Devices Rate',
        detail: 'Rate of jailbreaked devices of new devices in selected duration',
        key: 'jailbrokenpro',
      }, {
        title: 'Jailbreaked Devices\' Os Distribution',
        detail: 'Number of jailbreaked systems of new devices in selected duration',
        key: 'created',
      }, {
        title: 'Unjailbreaked Devices\' Os Distribution',
        detail: 'Number of jailbreaked systems of new devices in selected duration',
        key: 'nocreated',
      }, {
        title: 'Jailbreaked Devices Rate',
        detail: 'Rate of jailbreaked systems of new devices in selected duration',
        key: 'createdpro',
      }, {
        title: 'Page Views',
        detail: 'Number of visiting time on page in selected duration ',
        key: 'page_time',
      }, {
        title: 'Unique Devices on Page',
        detail: 'Number of devices on page in selected duration',
        key: 'page_peoplenum',
      }, {
        title: 'Duration per Page',
        detail: 'Avg. visiting time on page in selected duration',
        key: 'page_staytime',
      }, {
        title: 'Exit Rate',
        detail: 'Rate of app leaving over page visiting in selected duration ',
        key: 'page_leavepro',
      }, {
        title: 'Event Occurrences',
        detail: 'Event occurrences in selected duration.',
        key: 'event_time',
      }, {
        title: 'Unique Devices on Event',
        detail: 'Number of devices triggering one event in selected duration.',
        key: 'event_peoplenum',
      }, {
        title: 'Avg. Events per Session',
        detail: 'Avg.number of triggering events in selected duration',
        key: 'event_happen',
      }, {
        title: 'Unique Event Devices / Active Devices',
        detail: 'Rate of devices triggering events of active devices in selected duration',
      }],
      selectTab: {
        title: 'Select metrics',
        title2: 'Select dimentions',
        tab1: 'Devices and Sessions',
        tab2: 'Page Views',
        tab3: 'Evetnts',
        page: 'Page Name',
        event: 'Event Name',
        prompt1: 'The metrics can not be compared together. You should add another metric.'
      },
      xdimension: [{
        en: 'day',
        ch: 'Day'
      }, {
        en: 'hour',
        ch: 'Hour',
      }, {
        en: 'partnerid',
        ch: 'Channel'
      }, {
        en: 'version',
        ch: 'Version Name'
      }, {
        en: 'userType',
        ch: 'Segment'
      }, {
        en: 'mobile',
        ch: 'Models'
      }, {
        en: 'os',
        ch: 'OS'
      }, {
        en: 'pixel',
        ch: 'Resolutions'
      }, {
        en: 'isp',
        ch: 'Carriers'
      }, {
        en: 'channel',
        ch: 'Connectivity'
      }, {
        en: 'country',
        ch: 'Global'
      }, {
        en: 'province',
        ch: 'Provinces of China'
      }, {
        en: 'startlevel',
        ch: 'Amount of devices',
      }, {
        en: 'usetimelevel',
        ch: 'Session Duration',
      }, {
        en: 'intervallevel',
        ch: 'Session Interval',
      }],
      metric: [{
        first: 'Total Devices',
        dimension: ['day', 'partnerid', 'version', 'mobile', 'os', 'pixel', 'isp', 'channel', 'country', 'province'],
        metric: 'totaluser'
      }, {
        first: 'New Devices',
        dimension: ['day', 'hour', 'partnerid', 'version', 'mobile', 'os', 'pixel', 'isp', 'channel', 'country', 'province'],
        metric: 'newuser'
      }, {
        first: 'Active Devices',
        second: ['Daily Active Devices', 'Weekly Active Devices', 'Monthly Active Devices', 'DAU/MAU'],
        dimension: ['day'],
        metric: 'launchuser',
        enSecond: ['daylaunchuser', 'weeklaunchuser', 'monthlaunchuser', 'DAU/MAU']
      }, {
        first: 'New Devices Retention',
        second: [],
        dimension: ['day'],
        metric: 'keepuser'
      }, {
        first: 'Active Devices Retention',
        second: [],
        dimension: ['day'],
        metric: 'keeplaunchuser'
      }, {
        first: 'Uninstall',
        dimension: ['day'],
        metric: 'uninstallUser',
      }, {
        first: 'Churn',
        second: ['Number of lossing users  (not using app for 7 days)', 'Number of lossing users  (not using app for 14 days)', 'Number of lossing users (not using app for 30 days)',
          // 'days used before user loss (not using app for 7 days)', 'days used before user loss (not using app for 14 days)', 'days used before user loss (not using app for 30 days)',
          // 'frequency used before user loss (not using app for 7 days)', 'frequency used before user loss (not using app for 14 days)', 'frequency used before user loss (not using app for 30 days)',
          // 'time used before user loss (not using app for 7 days)', 'time used before user loss (not using app for 14 days)', 'time used before user loss (not using app for 30 days)'
        ],
        dimension: ['day'],
        metric: 'loseuser',
        enSecond: ['loseuser_loseuser7', 'loseuser_loseuser14', 'loseuser_loseuser30',
          // 'loseuser_loseday7', 'loseuser_loseday14', 'loseuser_loseday30',
          // 'loseuser_losetime7', 'loseuser_losetime14', 'loseuser_losetime30',
          // 'loseuser_loselong7', 'loseuser_loselong14', 'loseuser_loselong30'
        ]
      }, {
        first: 'Returning Devices',
        second: ['Number of returning users(not using app for 7 days)', 'Number of returning users(not using app for 14 days)', 'Number of returning users(not using app for 30 days)'],
        dimension: ['day'],
        metric: 'keeplose',
        enSecond: ['keeplose_user7', 'keeplose_user14', 'keeplose_user30']
      }, {
        first: 'Returning Devices',
        second: ['Returning Devices in Last 7 days', 'Returning Rate in Last 7 days'],
        dimension: ['day'],
        metric: 'retetionuser',
        enSecond: ['retetionuser', 'retetionuser_retetionrate7']
      }, {
        first: 'Update Devices',
        dimension: ['day'],
        metric: 'versionupdate'
      }, {
        first: 'Sessions',
        second: ['Sessions', 'Avg. Sessions per Devices',],
        dimension: ['day'],
        metric: 'startup',
        enSecond: ['startup', 'startup_average',]
      }, {
        first: 'Session Duration',
        second: ['Session Duration', 'Avg. Duration per Device', 'Session Duration Distribution'],
        dimension: ['day'],
        metric: 'useDuration',
        enSecond: ['usetime_single', 'usetime_average', 'usetime_singledistribute']
      }, {
        first: 'Interval',
        second: ['Interval Distribution'],
        dimension: ['day'],
        metric: 'startup',
        groupby: 'intervallevel',
      }, {
        first: 'Jailbreaked and Cracked',
        second: ['Jailbreaked Devices', 'Unjailbreaked Devices', 'Jailbreaked Rate', 'With Cracked Apps', 'Without Cracked Apps', 'Cracked Rate'],
        dimension: ['mobile'],
        metric: 'newuser',
        enSecond: ['jailbroken', 'nojailbroken', 'jailbrokenpro', 'created', 'nocreated', 'createdpro']
      },],
      pageAndEvent: [{
        first: 'Page Name',
        second: ['Page Views', 'Devices', 'Duration per Page', 'Exit Rate'],
        dimension: ['day'],
        enSecond: ['page_time', 'page_peoplenum', 'page_stayDuration', 'page_leavepro']
      }, {
        first: 'Event Name',
        second: ['Event Occurrences', 'Unique Event Devices', 'Occurrences / Session'],
        dimension: ['day'],
        enSecond: ['event_time', 'event_peoplenum', 'event_happen']
      }],
      namelist: {
        _totaluser: 'Total Devices',
        _newuser: 'New Devices',
        _launchuser: 'Active Devices',
        daylaunchuser: 'Daily Active Devices',
        weeklaunchuser: 'Weekly Active Devices',
        monthlaunchuser: 'Monthly Active Devices',
        daumau: 'DAU/MAU', // 特殊处理key
        _keepuser: 'New Devices Retention',
        _keeplaunchuser: 'Active Devices Retention',
        _loseuser: 'Churn users',
        loseuser_loseuser7: 'Churn（Didn\'t open app in 7 Consecutive Days）',
        loseuser_loseuser14: 'Churn（Didn\'t open app in 14 Consecutive Days）',
        loseuser_loseuser30: 'Churn（Didn\'t open app in 30 Consecutive Days）',
        loseuser_loseday7: 'days used before user loss(not using app for 7 days)',
        loseuser_loseday14: 'days used before user loss(not using app for 14 days)',
        loseuser_loseday30: 'days used before user loss(not using app for 30 days)',
        loseuser_losetime7: 'frequency used before user loss(not using app for 7 days)',
        loseuser_losetime14: 'frequency used before user loss(not using app for 14 days)',
        loseuser_losetime30: 'frequency used before user loss(not using app for 30 days)',
        loseuser_loselong7: 'time used before user loss(not using app for 7 days)',
        loseuser_loselong14: 'time used before user loss(not using app for 14 days)',
        loseuser_loselong30: 'time used before user loss(not using app for 30 days)',
        _keeplose: 'Returning Devices',
        keeplose_user7: 'Returning Devices (Didn\'t open app in 7 Consecutive Days)',
        keeplose_user14: 'Returning Devices (Didn\'t open app in 14 Consecutive Days)',
        keeplose_user30: 'Returning Devices (Didn\'t open app in 30 Consecutive Days)',
        _retetionuser: 'Returning Devices',
        retetionuser: 'Returning Devices in Last 7 days',
        retetionuser_retetion7: 'Returning Devices in Last 7 days',
        retetionuser_retetionrate7: 'Returning Rate in Last 7 days',
        _versionupdate: 'Update Devices',
        _startup: 'Sessions',
        _intervallevel: 'Sessions',
        startup: 'Sessions',
        startup_average: 'Avg. Sessions per Devices',
        _usetime: 'Session Duration',
        usetime_single: 'Session Duration',
        usetime_average: 'Avg. Duration per Device',
        usetime_singledistribute: 'Session Duration Distribution',
        startup_interval: 'Interval Distribution',
        _jailBreakcrack: 'Jailbreaked and Cracked',
        jailbroken: 'Jailbreaked Devices',
        nojailbroken: 'Unjailbreaked Devices',
        jailbrokenpro: 'Jailbreaked Rate',
        created: 'With Cracked Apps',
        nocreated: 'Without Cracked Apps',
        createdpro: 'Cracked Rate',
        page_time: 'Page Views',
        page_peoplenum: 'Devices',
        page_staytime: 'Duration per Page',
        page_leavepro: 'Exit Rate',
        event_time: 'Event Occurrences',
        event_peoplenum: 'Unique Event Devices',
        event_happen: 'Occurrences / Session',
      },
    },

    version: {
      platform: 'Platform',
      appversion: 'Version Name',
      createtime: 'Create Time',
      state: 'Show the Versions',
      code: 'Version Code',
      updatetime: 'Update Time',
      sdkversion: 'SDK Version',
      show: 'Show',
      hide: 'Hide',
      pagesize: '/Page'
    },
    accountAuthorization: {
      title: 'Permissions',
      createNewUser: 'Invite New User',
      delete: 'Delete',
      username: 'Username',
      role: 'Role',
      remarks: 'Remarks',
      jurisdiction: 'Jurisdiction',
      createtime: 'Create Time',
      operate: 'Operations',
      creator: 'Creator',
      ordinaryuser: 'Ordinary User',
      partneruser: 'Channel Partner',
      pagesize: 'Records /Page',
      del: 'Are you sure you want to delete the user？',
    },
    authorize: {
      createAuthor: 'Invite New User',
      editAuthor: 'Edit the Permissions',
      modal: {
        content: 'The invitee is already been invited，are you sure you want to edit the permission？'
      },
      messageInfo: {
        addsucc: 'Successfully added',
        addfail: 'Failed to add. Try again, please.',
        editsucc: 'Successfully updated',
        editfail: 'Failed to edit. Try again, please.',
      },
      account: {
        title: 'Email',
        placeholder: 'Input the email of invitee, please',
        prompt: 'Email cannot be blank.',
        nameErr: 'The format of the email is error',
        nameIsMySelf: 'You can not give the permission of applications to yourself',
      },
      remarks: {
        title: 'Notes',
        placeholder: 'Input important information such as company information or contact name, less than 50 characters.',
      },
      role: {
        title: 'Roler',
        ordinaryUser: 'Users',
        partner: 'Promotion Partners',
        administrators: 'Administrator',
      },
      selApp: {
        title: 'Select an application',
        addApp: 'Add an application',
        modaltitle: 'Select an application, please',
        selected: 'Selected',
        selectedApp: 'Selected',
        num: ' ',
        app: 'applications',
        channel: 'Promotion Partners',
        all: 'All',
        total: 'total',
        type: ' ',
        prompt: 'Select an application, please',
        nopage: 'Please authorize at least one page ',
      },
      channelAuthorize: {
        title: 'Promotion Partners',
        all: 'All channels',
        part: 'Partial channels',
        prompt: 'Select an channel, please',
      },
      dataAuthorize: {
        title: 'Permissions',
        all: 'All permissions',
        jurisdiction: 'Channel Data',
      },
      manageAuthorize: {
        all: 'Admin',
      },
    },
    manageEvent: {
      tabs: {
        list: 'Event list',
        pending: 'Pending Events',
        recycle: 'Event Recycle Bin',
      },
      table: {
        displayname: 'Event name',
        eventid: 'Event ID',
        eventlabel: 'Label',
        platformid: 'Platform',
        registertime: 'Register time',
        changetime: 'Change time',
        labellimit: 'Labellimit',
        operation: 'Operation',
        deletetime: 'Delete time',
        normal: 'Normal',
        excess: 'Excess',
        edit: 'Edit',
        labelmanage: 'Label manage',
        calculation: 'Calculation',
        recovery: 'Recovery',
        del: 'Delete',
      },
      modal: {
        listdel: {
          testing: 'The events such as',
          funnelInfo: 'have been used in funnels. Those funnels will been deleted when the events were been deleted。And besides，',
          a: 'the system won\'t compute the data of them continuatively, and will transfer them to Event Recycle Bin.',
          b: 'If you want to compute the data of them again, you should transfer them back.',
          c: 'Are you sure you want to delete the event?',
        },
        pendingdel: {
          a: 'The system will transfer the events to Event Recycle Bin.',
          b: 'If you want to compute the data of them again, you should transfer them back.',
          c: 'Are you sure you want to delete the event?',
        },
        recycledel: {
          a: 'The event will be deleted forever after emptying the recycle bin. Even you add event of same ID, you can not get data of same event.',
          b: 'Are you sure to delete the event forever?',
        },
        pendingreduce: {
          a: 'This event will be shifted into event list and get operated after executing computing.',
          b: 'Please reserve events reasonably considering the speed of spreadsheet.',
          c: 'Are you sure to operate this event?',
        },
        add: {
          a: 'If you decide to recover,it will recover to its original place. If the event is in the event list, it will recover to opereate or you need to confirm "begin to operate" to start its operation.',
          b: 'Are you sure to recover this event?',
        },
      },
      index: {
        a: ': Event operating normally ',
        b: ': Save events that you deleted. You can recover it to operate computing.',
        c: ': Events will be shifted to to do list when you have more than 1000 events. You need to reopen operation task.',
        d: ': Rename the event ID to identify event quickly.',
        e: ': Date of counting the event firstly.',
        f: ': Time of last editing events.including shifting to recycle bin, recovering to event list and renaming event ID.',
        g: ': after getting deleted,data of event of matching ID will not be received until the event get recovered.',
        h: ': 表示Label现在或者曾经达到过量的状态，一般分为正常和过量使用。正常，表示所有Label都在计算中，无需手动操作。过量使用，表示Label数量现在或者曾经超过限量，新Label需要手动添加到计算列表。',
      },
    },
    manageLabel: {
      tabs: {
        labellist: 'Label List',
        pending: 'Pending Labels',
        recycle: 'Labels Recycle Bin'
      },
      modal: {
        labellistdel: {
          a: 'After deleting the labels,data of those labels won\'t be counted anymore and will be shifted to label recycle bin',
          b: 'If you want to reoperate,please find the label in the label bin and confirm "recover".',
          c: 'Are you sure to delete Label?',
        },
        pendingdel: {
          a: 'Delete and shift to label recycle bin.',
          b: 'If you want to reoperate,please find the label in the label bin and confirm "recover".',
          c: 'Are you sure to delete Label?',
        },
        recycledel: {
          a: 'The label will be deleted forever after emptying the recycle bin.Even you add label of same ID,you can not get data of same label.',
          b: 'Are you sure to delete Label forerver?',
        },
        pendingreduce: {
          a: 'This label will be shifted into label list and get operated after executing computing.',
          b: 'Please reserve events reasonably considering the speed of spreadsheet.',
          c: 'Are you sure to operate label?',
        },
        add: {
          a: 'If you decide to recover,it will recover to its original place. If the label is in the label list, it will recover to opereate or you need to confirm"begin to operate" to start its operation.',
          b: 'Are you sure to recover label?',
        },
      },
    },
    manageInfo: {
      info: 'Information',
      form: {
        appName: 'Application Name',
        appIcon: 'iCon',
        appType: 'Category',
        platform: 'Platform',
        showWatch: 'WatchKit Data',
        watchOn: 'Show',
        watchOff: 'Hide',
        createDate: 'Created Date',
        appId: 'App ID',
        copyId: 'Copy',
        authorize: 'Creator',
        saveInfo: 'Save',
        deleteApp: 'Delete the app',
        deleteConfirm: 'All app and data will be deleted forever.Are you sure to delete it?',
        deleteAuthority: 'Delete the promission'
      },
      tip: {
        imgOverSize: 'The file have exceeded the size limit.',
        imgOverSizeDecs: 'The file have exceeded the size limit.',
        copySuccessTip: 'Successfully copied',
        copyErrorTip: 'Failed',
        deleteProSuccess: 'Successfully deleted',
        deleteProError: 'Failed to delete the application',
        saveSuccess: 'Successfully saved',
        saveError: 'Failed to save',
        saveNameDuplicate: 'The application name is used',
        formatErrorTitle: 'The format is wrong',
        formatErrorDesc: 'It must be Jpg or png.',
      },
      footer: {
        sdk: 'Download SDK',
        doc: 'Integration Guide',
        item: 'Terms of Service',
        privacy: 'Privacy Policy',
        blog: 'Blog',
        phone: 'Tel',
        qq: 'QQ',
        email: 'Email',
        copyright1: '京ICP备12005794号',
        copyright2: '京ICP证130311号',
        copyright3: '京公网安备11010102001221号',
      },
    },
    openApi: {
      title: 'Data APIs',
      accessKey: 'Access Key',
      applyCode: 'Apply for Access Key',
      applyTip: 'The total decives of your appliction is too less to apply for Access Key',
      validIP: 'Add right IP, please.',
      invalidIP: 'The IP is wrong',
      copy: 'Copy',
      saveIP: 'Save',
      cancel: 'Cancel',
      editIP: 'Edit',
      deleteIP: 'Delete',
      deleteTip: 'Are you sure you want to delete this IP ?',
      intro: {
        title: 'Data APIs Introduction',
        desc: ['Data APIs help you extract data calculated by TalkingData so that you can store important data or organize your own operation report to create unique analytics platform with TalkingData\'s ability. ',
          '1.For calling security,you should have an Access Key which is a security credential for app. Effective time are only half of an hour for first application access key.',
          '2.You should provide server IP address of calling interface.Only IP with your approval can extract data.',
          '3.To assure efficiency,product with more than 1000 users can apply data interface.',
          '4.To assure data security,each app can support less than 5 IP addresses to extract data with APIs.',
        ],
        helpDoc: 'Data APIs Guige',
      },
      tip: {
        copySuccess: 'Successfully Copied',
        copyError: 'Failed',
      },
    },
    manageChannel: {
      title: 'Channel Management',
      num: ' ',
      validTips: 'Please select an effective channel',
      table: {
        platformid: 'Platform',
        partnername: 'Channel Id',
        displayname: 'Name',
        registertime: 'Date',
        channelstr: 'Merge',
        isdisplay: 'Hide the Channels',
        channelmanage: 'Channel Permissions',
        authorized: 'Count of Channel Permissions ',
        query: 'Old form',
        querylink: '>>Channel Data System',
        show: 'On',
        hide: 'Off',
        merge: 'Merge',
        split: 'Split',
        mergeinfo: 'multi-channel data consoildation',
        splitinfo: 'spilt consolidation data to different channels and display respectively ',
        userPass: 'Account & Password',
        user: 'Account',
        password: 'Password',
        splitMerge: 'Merge/ Split',
      },
      queryinfo: {
        a: 'We won\'t offer support for Old Channel Data System since 2017-6-1,',
        b: 'we provided a new way to help you check channel data,',
        c: ' more conveniently and more securely.',
        t: 'Notes',
        btn: 'Login Channel Data System',
      },
      modal: {
        merge: {
          title: 'Select the channels supporting the same platform to merge together.',
          number: 'Selected Channels',
        },
        split: {
          title: 'The channel will be split to different channels such as:',
          number: 'Split',
        },
      },
      index: {
        a: ': Rename the channel ID with familiar name to identify easily. TalkingData provides popular channel names and renames  channels according to standards. ',
        b: ':Date of first calculating this channel data.',
        c: ': After hiding the channel,channel won\'t displayed in the function list of channel analytics and screening, which prevents unnecessary display from influencing report',
        d: ': Consolidation can intergrate different channels for data intergration. Spilt can display the consolidation channel respectively',
      },
    },
    manageAlerts: {
      alert: 'Alerts',
      history: 'Notification',
      name: 'Alert Name',
      conditions: 'Conditions',
      receiver: 'Recevier',
      status: 'Status',
      normal: 'Enabled',
      diable: 'disabled',
      delete: 'Delete',
      add: 'Add ',
      new: 'New Alert',
      time: 'time',
      content: 'Content',
      notice: 'Notification',
      mail: 'email',
      addmail: 'Add Email Address',
      metrics: {
        title: 'Metric',
        new: 'New Devices',
        channal: 'New Devices of Selected Channel',
        active: 'Active Devices',
        session: 'Sessions',
        event: 'Event Occurences',
        err: 'Errors',
      },
      range: {
        title: 'Range',
        day: 'Whole Day',
        am: 'Before 8:00 am',
        pm: 'Before 15:00 pm',
      },
      evalue: {
        title: 'Evaluation',
        gt: 'More than',
        let: 'Less than',
        pre: 'Variation to previous day',
        num: 'Number',
      },
      threshold: {
        title: 'Threshold',
        percent: 'Percent',
        num: 'Number',
      },
      errInfo: {
        a: 'Threshold value can not be blank.',
        b: 'Threshold value must be  an integer',
        c: 'The threshold value cannot be empty',
        d: 'Please input the correct email address',
        e: 'The email address cannot be empty',
        f: 'Warning rule name cannot be empty',
        g: 'Warning rule name cannot exceed 64 characters',
        h: 'Please enter a number within 100, two decimal reserved',
      },
      delInfo: [
        'Are you sure to delete the warning rule？',
        'Are you sure to delete the warning history？',
      ],
    },
    smart: {
      title: 'Smart Code ',
      intro: {
        title: 'What is "smart event"',
        desc: 'Without code, you just need to click and then create event data ',
        helpView: 'click me, view the demo video',
      },
      closeTip: {
        tipResult: 'Please try it later!',
        tipIntro1: 'Other team member are using smart event to prevent from intervention，',
        tipIntro2: 'You can\'t use it now,please try again later',
      },
      connectTip: {
        openApp: 'Open app on your device',
        timeTip: {
          startCon: 'Before openning it',
          midCon: 'Shaking devices in a second',
          endCon: 'Time',
        },
        openTip: '（need to open it when the app doesn\'t run in the background）',
        processStatus: 'Try to connect…',
      },
      connectSteps: {
        stepOne: 'Shake to connect a device',
        stepOneScan: 'Scan to connect a device',
        stepTwo: 'The platform will obtain interface of the connecting device automatically',
        stepThree: 'chose the elements to append events',
        stepFour: 'Begin getting data when the event is effective',
        stepDemo: 'Click me to view the demo video',
      },
      attention: {
        title: 'Notes',
        verTip: 'If you want to use Smart analysis,please use the latest SDK',
        iosSDK: 'iOS SDK V2.0 beta or above',
        iosSDK4: 'iOS SDK V4.0.41 or above',
        androidSDK: 'Android SDK V2.0 beta or above',
        androidSDK4: 'Android SDK V4.0.36 or above',
        networkTip: 'Please use this function in WiFi environment',
      },
      connectInfo: {
        shakeTime: 'Shake time',
        isConnect: 'A device noted,do you connect it？',
        connect: 'Yes',
        reject: 'No',
      },
      errorTip: 'Failed to get data,please try again',
      traceText: {
        openTip: 'The notification of additional trackable elements',
        closeTip: 'Turn off the notification of additional trackable elements',
        traceable: 'Trackable elements',
        hasTrace: 'Elements tracked',
        curEle: 'Elements selected',
      },
      disconnect: {
        disBtn: 'Disconnect',
        eventName: 'Event test',
        happenTime: 'Occurrence time',
        isVaild: 'Effective to users',
        vaild: 'Executed',
        invaild: 'Unexecuted',
        noEvent: 'Please add the event button on your device！',
      },
      addEvent: {
        title: 'Name the event，add data tracking point',
        subTitle: 'collect data when user click elements on the interface',
        placeholder: 'Name of clicking event',
        hasExist: 'The event name exist,please rename it',
        comfirm: 'Sure',
        cancel: 'Cancel',
      },
      editEvent: {
        allEvent: 'All events',
        curPageEvent: 'Current event',
        hasChangeEvent: 'Changing event',
        searchEvent: 'Input keywords',
        confirm: 'Sure',
        cancel: 'Cancel',
        lastSavetime: 'Last saving time',
        pushAll: 'All effective',
        cancelEdit: 'Cancel alteration',
        pushSuccessTip: 'All submittal are effective',
        pushErrorTip: 'All submittal fail',
        cancelEditTip: 'Success to cancel change',
        cancelErrorTip: 'Fail to cancel change',
        noSaveEvent: 'You haven\'t saved the event',
      },
    },
    eauth: {
      welcome: {
        title: 'Eauth - Easily establish the authenticity of the users',
        description: 'Simple integration，free interface，stable channel and free SMS help you to concentrate on your product',
        smsTitle: 'SMS auth at sign-up',
        smsDes: 'Facilitate SMS verification with products registered by phone number',
        phoneTitle: 'Bind account to mobile phone',
        phoneDes: 'Enhance communication with users by encouraging mobile phone binding behaviour with virtual reward',
        passwordTitle: 'Get temporary password',
        passwordDes: 'Send temporary password to facilitate a quick login and password reset when users forget password',
        dredge: 'Start Now',
        toUse: 'Start Now',
        knowMore: 'Learn more about eauth',
      },
      overview: {
        appid: 'unique identifier of your app',
        secretid: 'required for integration',
        serverSecurity: 'required for secure authentication when you verify the authcode through the server',
        integretionInfo: 'Integrate now to get free SMS',
        gotIntegeretion: 'Rapid Integration',
        balance: 'Account Balance',
        sendoutAll: 'SMS Sent this Month',
        verifyAll: 'Successful Auth',
        remainFree: 'Free SMS Remaining',
        free: 'Free SMS',
        perday: 'per day',
        more: 'Get more',
        trend: 'Trend of Auth',
        times: 'By times',
        phone: 'By phone',
        device: 'By device',
        day7: 'Past 7 Days',
        day30: 'Past 30 Days',
        today: 'Today',
        yesday: 'Yesterday',
        month: 'This Month',
        day: 'Days',
        hour: 'Hours',
        apply: 'Successful Application',
        sendout: 'SMS Sent',
        verify: 'Successful Auth',
        rate: 'Auth Success Rate',
      },
      list: {
        des: 'Auth lists in the last two months',
        status: 'Status',
        phoneNum: 'Phone',
        attribution: 'Attribution',
        dev: 'Devive ID',
        carriers: 'Carriers',
        sendTime: 'SMS Sent Time',
        authTime: 'SMS Authed Time',
      },
      message: {
        des: 'Modify the product name to get 1000 free SMS per day; Apply for dedicated channel to get 10000 free SMS per day and modify SMS signature',
        dedicate: 'Click here for detailed instructions',
        name: 'Product Name',
        nameDefine: 'Product name can be modified；Default SMS Signature is 【eauth】，which can be modified if you apply for dedicated channel',
        code: 'Auth Code Hint',
        codeDefine: 'The system automatically generates auth code',
        addition: 'Additional Information',
        additionDefine: 'Additional Information cannot be modified',
        example: 'Example',
      },
    },
    datachart: {
      msgerror: 'Fail to loading data',
      countryTable: 'Nation list',
      regionTable: 'Province list (Note：Exclude Hongkong, Macao and Taiwan)',
      country: 'Country',
      region: 'District',
      newuser: 'New users',
      newuserProportion: 'Rate of new users',
      launchuser: 'Actice users',
      launchuserProportion: 'Rate of active users',
      startup: 'Sessions',
      daylaunchuser: 'Daily Active Users',
      weeklaunchuser: 'Weekly Active Users',
      monthlaunchuser: 'Monthly Active Users',
      daumau: 'DAU/MAU',
      onceuser: 'One Session Devices',
      loseuser: 'Churn users',
      backuser: 'Returning Devices',
      retetionuser: 'Returning users',
      starttime: 'Start-up time',
      uninstalluser: 'Uninstall',
      uninstallUser: 'Uninstall',
      jailbroken: 'Jailbreaked',
      nojailbroken: 'Unjailbreaked',
      jailbrokenpro: 'Rate of Jailbreaked',
      versionupdate: 'Upgraded users',
      created: 'Cracked',
      nocreated: 'Uncracked',
      createdpro: 'Rate of cracked',
      intervallevel: 'Details of using intervals',
      startup_interval: 'Sessions',
      totaluser: 'Accumlated users',
      partnerid: 'Channel Name',
      version: 'Version',
      channel: 'Connectivity',
      isp: 'Carriers',
      pixel: 'Device Distribution (Resolution)',
      os: 'Device Distribution (OS)',
      userType: 'Segement',
      mobile: 'Device Distribution (Model)',
      startup_average: 'Avg. Sessions per Devices',
      startlevel: 'Sessions',
      startup_startuptime: 'Amount of devices',
      retetionuser_retetionrate7: 'Returning Rate in Last 7 days',
      retetionuser_retetion7: 'Returning Devices in Last 7 days',
      usetime_singledistribute: 'Session Duration Distribution ',
      usetimelevel: 'Detail of Session Duration',
      usetime_average: 'Duration per Device',
      usetime_single: 'Session Duration',
      keeplose_user7: 'Returning Devices (Didn\'t open app in 7 Consecutive Days)',
      keeplose_user14: 'Returning Devices (Didn\'t open app in 14 Consecutive Days)',
      keeplose_user30: 'Returning Devices (Didn\'t open app in 30 Consecutive Days)',
      loseuser_loseuser7: 'Churn（Didn\'t open app in 7 Consecutive Days）',
      loseuser_loseuser14: 'Churn（Didn\'t open app in 14 Consecutive Days）',
      loseuser_loseuser30: 'Churn（Didn\'t open app in 30 Consecutive Days）',
      loseuser_loseday7: 'days used before user loss(not using app for 7 days)',
      loseuser_loseday14: 'days used before user loss(not using app for 14 days)',
      loseuser_loseday30: 'days used before user loss(not using app for 30 days)',
      loseuser_losetime7: 'frequency used before user loss(not using app for 7 days)',
      loseuser_losetime14: 'frequency used before user loss(not using app for 14 days)',
      loseuser_losetime30: 'frequency used before user loss(not using app for 30 days)',
      loseuser_loselong7: 'time used before user loss(not using app for 7 days)',
      loseuser_loselong14: 'time used before user loss(not using app for 14 days)',
      loseuser_loselong30: 'time used before user loss(not using app for 30 days)',
      keepuser: 'Retention of New Devices',
      keeplaunchuser: 'Retention of Active Devices',
      page_time: 'Page Views',
      page_leavepro: 'Exit Rate',
      page_staytime: 'Duration per Page',
      page_peoplenum: 'Unique Devices on Page',
      event_time: 'Event Occurence',
      event_happen: 'Event frequency',
      event_peoplenum: 'Unique Devices on Event',
    },
    eventAnalysis: {
      title: 'Event Analysis',
      table: 'Event List',
      jumpinfo: 'Add Smart Events',
      event: 'All Event',
      smart: 'Smart Event',
      // code: 'Code Event',
      custom: 'Custom Event',
      standard: 'Standard Event',
      eventname: 'Display Name',
      eventid: 'EventID',
      eventtype: 'Type',
      platform: 'Platform',
      eventuser: 'Unique Devices on Event',
      eventcount: 'Event Occurrences',
      eventhappen: 'Occurrences / Session',
      set: 'Operation',
      index: {
        a: ': Number of event occurrence in selected duration.',
        b: ': Number of devices triggering events in selected duration.',
        c: ': Avg.number of triggering events at a time in selected duration.',
        d: 'Note: To assure computing speed,we only offer customer events data in last year. Please contact us for more info.',
      },
    },
    eventdetails: {
      day: 'Date',
      diff: 'Comparison',
      diffdate: 'Date',
      pro: 'Daily',
      title: 'Event',
      trend: 'Event trend',
      trenddetails: 'detail of event trend',
      analysis: 'Parameter Analysis',
      label: 'Label distribution',
      eventvalue: 'Value',
      eventcount: 'Event Occurrences',
      eventuser: 'Unique Devices on Event',
      happen: 'incidence of active user',
      startup: 'Occurrences per Session',
      eventcountDiff: 'Event Occurrences( Compare) ',
      eventuserDiff: 'Unique Devices on Event (Compare)',
      happenDiff: 'Incidence of active user(Compare)',
      startupDiff: 'incidence of active user(compare)',
      options: 'Options',
      value: 'Value',
      info: 'Total number of messafes',
      addValue: 'Value Sum',
      set: 'Operation',
      setVal: 'Value distribution',
      labelTable: 'Label',
      eventLabel: 'Event label',
      details: 'Details',
      up: 'Fold',
      proportion: 'Proportion',
      proportionTotal: 'Accumlated proportion',
      top100: 'Top100',
      eventOption: 'Name of event parameter',
      eventOptionNum: 'Value of event parameter',
      eventLabelDis: 'Distribution of event parameter',
      top100label: 'Top 100 Labels of selected parameter',
      top100option: 'Top 100 Values of Label',
      index: {
        a: ': Number of event occurrence in selected duration.',
        b: ': Number of devices triggering events in selected duration.',
        c: ': Rate of active devices triggering events of all active devices in selected duration ',
        d: ': Avg.number of triggering events at a time in selected duration.',
      },
      optionIndex: {
        a: ': Track and add parameter name of events to describe behavior.',
        b: ': different parameter value of different event',
        c: ': Number of event parameter occurrence and different event parameter occurrence in selected duration',
        d: ': Number of event occurrence of parameter value under Top 100 label.',
        e: ': 所选日期内参数某个取值的发生次数/全部取值发生次数的比例。',
        f: ': 按照占比从上而下的累计，累计到最后一项时，就是100%。比如第二种商品累计占比为第一、二种所占比例之和，第三种商品累计占比为第一、二、三种所占比例之和，以此类推至到100%。这种方式可以直观显示随类别增加，所显示类别的所占比例之和，直观看出贡献率较高的参数值。',
      },
      labelIndex: {
        a: ': When tracking events, TalkingData App Analytics offers event label to assign same EventID for events of same or familiar category. Reach the goal of differentiating and tracking multi events by assigning different event labels.',
        b: ':Number of event label occurrence in selected duration',
        c: ': ',
      }
    },
    funnel: {
      title: 'Conversion funnel',
      funnelBtn: 'Create conversion funnel',
      setfunnel: 'Edit conversion funnel',
      edit: 'edit',
      set: 'set',
      addStep: 'Newly added steps',
      funnelInfo: 'Based on events triggered, construct conversion funnel of at most 8 steps. System will filter step by step and then calculate the conversation rate of users during the process. ',
      placeholder: 'choose user to trigger events',
      funnelname: 'Funnels',
      start: 'The First Step',
      end: 'The Goal',
      step: 'Step',
      null: 'Not null',
      name: 'Name',
      event: 'Event',
      analysis: 'On event',
      stepname: 'Step Name',
      repeatStepName: 'Reinput step name as the name has existed.',
      update: 'Edited successfully',
      create: 'Created successfully',
      delinfo: 'Are you sure to delete this conversion funnel？',
      eventdelinfo: 'This event has been deleted',
      rate: 'Overall conversation rate',
      number: 'Total Devices',
      achieve: 'Devices Converted',
      noAchieve: 'Devices Dropped Off',
      lowRate: 'The worst step',
      details: 'Detail of conversation funnel ',
      eventuser: 'Devices',
      preRate: 'Conversation rate compared with last step',
      noLess: 'more than two steps',
      stepNumber: ['Step 1：', 'Step 2：', 'Step 3：', 'Step 4：', 'Step 5：', 'Step 6：', 'Step 7：', 'Step 8：'],
      targetStep: {
        name: 'Step',
        name2: '',
        colon: ': ',
      },
    },
    portrait: {
      info: ['Sample：', 'active devices in selected time'],
      sex: 'Age distribution',
      age: 'Gender distribution',
      pre: 'Population characteristics TGI Index',
      people: 'Characteristics',
      equ: 'mobile app preference',
      man: 'Male',
      woman: 'Female',
      unknown: 'Unknown',
      // agegroup: ['<19', '19-25', '26-35', '36-45', '46-55', '>55', 'Unknown'],
      agegroup: ['<17', '18-24', '25-29', '30-34', '35-39', '40-44', '45-49', '>50', 'Unknown'],
      indexInfo: 'Definition',
      indexbtn: {
        a: 'How to accquire more gender info？',
        b: 'How to accquire more age distribution info？',
      },
      index: {
        a: 'Calculate user portrait of active device under Android paltform by default. Data Update:The first Monday after activation 4 weeks ago.',
        b: ': TalkingData predicts gender distribution of users based on users\' app behavior.This gender refers to the gender of user behavior which is different from gender of ID card.',
        c: ': TalkingData predicts age distribution of users based on users\' app behavior.',
        d: ':(Number of device/active device of current characteristic of public) / (all TalkingData stock devices of same characteristic/all TalkingData stock devices)*100.',
        e: ': mobile app preference',
        f: ': classify and calculate rate of different devices in sample based on characteristic of device according to main mobile device market place.',
      },
    },
    errlist: {
      title: 'Error list',
      detail: 'Error detail',
      log: 'Origin Log',
      news: 'Basic Info',
      searchplace: 'Search by type of error or error detail',
      searchplace2: 'Search by error type',
      prev: 'Last one',
      next: 'Next one',
      prompt1: 'It\'s the first category now !',
      prompt2: 'It\'s the last category now',
      table: {
        columnt: 'Error type',
        columne: 'Error detail',
        column2: 'Latest occurrence time',
        column3: 'Errors on Today',
        column4: 'Errors in Last 7-days',
        column5: 'Errors in Selected Duration',
      },
      modaltab: {
        column1: 'Influenced Versions（Version Code）',
        column2: 'Last Time',
        column3: 'Last Version',
        column4: 'Errors on Today',
        column5: 'Errors in Last 7-days',
        column6: 'Errors in Selected Duration',
      },
      charts: {
        mobile: 'Model',
        os: 'OS',
        version: 'App Versions',
      },
    },
    errorAnalytics: {
      title: 'Analytics',
      trend: 'Trend of Error',
      version: 'Error of Top 10 Versions',
      versionCode: 'Error of Top 10 Channels',
      equipment: 'Error of Top 10 Models',
      system: 'Error of Top 10 OS',
      error: 'Errors',
      errorpro: 'Error Rate',
      dayPro: 'Daily avg. Error Rate',
      errorTime: 'Daily avg. Errors',
      index: {
        a: ': Errors in Selected Duration',
        b: ': Errors / Sessions in Selected Duration',
      },
    },
    // 复购分析
    repeatShopping: {
      title: 'Repeated Purchase Analysis',
      week: 'Week',
      month: 'Month',
      repeat: 'Repeated Purchase Rate',
      table: {
        date: 'Date',
        avg: 'Effetive Average',
        pay: 'Number of Paid Devices',
      },
      explain: {
        repeat: 'the number of re-paid devices in n weeks or months later',
        avg: 'judge the correctness of the future time in n weeks or months later, if not correct do not make it under consideration for calculation',
      },
    },
    // 交易分析
    transaction: {
      analytics: 'Transcation Analysis',
      payrate: 'Payment Rate of New Devices',
      date: 'Date',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      index: {
        analytics: {
          a: ': The number of orders produced in the selected period',
          b: ': The number of unique devices producing orders in the selected period',
          c: ': The sum of all orders in the selected period',
          d: ': The sum of orders / active devices number',
          e: ': New devices making order in the first day',
          f: ': Existing devices making the first order',
          g: ': Existing devcies making non-first order',
          h: ': Number of paid order in the selected period',
          r: ': Number of paid order / Number of order',
        },
        payrate: {
          a: ': the ratio of new devices to all new paid orders in the current day ',
          b: ': the ratio of new devices to all new paid orders in the current week',
          c: ': the ratio of new devices to all new paid orders in the current month',
        },
      },
      order: {
        tabs: 'order',
        day: {
          orderVol: 'average order amount per day',
          orderDev: 'average devices number making orders per day',
        },
        week: {
          orderVol: 'average order amount per week',
          orderDev: 'average devices number making orders per week',
        },
        month: {
          orderVol: 'average order amount per month',
          orderDev: 'average devices number making orders per month',
        },
        placeOrderCount: 'order amount',
        placeOrderDevice: 'devcies making orders',
      },
      income: {
        tabs: 'income',
        totalTransaction: 'transaction amount(points)',
        avgArpu: 'average ARPU',
        payOrderTotalAmount: 'total paied order amount(points)',
        userArpu: 'user ARPU',
      },
      pay: {
        index: 'the users composition of paid order ',
        tabs: 'paid devices',
        volumn: 'the volumn of  paid devices',
        payDeviceNew: 'new payment on current day',
        payDeviceUnNewFirst: 'non new device on the current day, first payment on the current day',
        payDeviceUnNewUnFirst: 'non new device on the current day, non first payment on the current day',
      },
      payOrder: {
        tabs: 'paid order',
        payOrderCount: 'the number of paid orders',
        payOrderRate: 'order completion rate',
      },
      dayPayRate: {
        tabs: 'rate of first day payment',
        avg: 'average of first day payment',
        newDevicePayFirstDay: 'rate of first day payment',
      },
      weekPayRate: {
        tabs: 'rate of first week payment',
        avg: 'average of first week payment',
        newDevicePayFirstWeek: 'rate of first week payment',
      },
      monthPayRate: {
        tabs: 'rate of first month payment',
        avg: 'average of first month payment',
        newDevicePayDayFirstMonth: 'rate of first month payment',
      },
    },
    // 交易分析概览值
    transactionOverview: {
      title: 'transaction analysis',
      launchuser: 'active devcies',
      order: 'devices making orders',
      pay: 'number of paid orders',
      conversion: ' the payment conversion rate',
      amount: 'the price of order(points)',
      purchase: 'repeatedly purchase rate',
      explain: {
        launchUser: ' the number of devices using the app at least once during the selected time period',
        placeOrder: ' the number of unique devices producing orders during the selected time period',
        payUser: ' the number of orders paid during the selected time period',
        viewPay: ' the number of paid users / the number of visitors',
        orderAmount: ' the total price of all orders during the selected time period',
      },
    },
    addUserGroup: {
      add: 'New Segments',
      edit: 'Edit Segments',
      groupName: 'Segment Name',
      placeholder: 'Name this segment (within 20 characters）',
      explain: 'Note:The system automatically creates a Segment for each of the selected platforms',
      verifyDate: 'Be carefully. The change of  time range may lead to invalid behavior time. ',
      groupRange: 'User',
      nameConflict: 'Name existed，palease rename',
      exprConflict: 'Condition existed, please rechoose',
      addSuccess: 'success',
      editSuccess: 'success',
      recover: 'recovery',
      userRange: [{
        label: 'New user',
        value: 'newuser',
      }, {
        label: 'Active user',
        value: 'enlaunchuser',
      }],
      dateType: [{
        label: 'Fixed date',
        value: 'fixed',
      }, {
        label: 'Roll date',
        value: 'roll',
      }],
      DateRange: [{
        label: 'week',
        value: 'week',
      }, {
        label: 'month',
        value: 'month',
      }],
      userAttrSel: {
        placeholder: 'Selected user properties',
        origin: 'Channel and Properties',
        originItem: [{
          label: 'Channel',
          placeholder: 'All channel',
        }, {
          label: 'Country and region',
          placeholder: 'All country and region',
        }, {
          label: 'Operator',
          placeholder: 'All Operator',
        }],
        mobile: 'Device properties',
        mobileItem: [{
          label: 'Model',
          placeholder: 'All model',
        }, {
          label: 'OS',
          placeholder: 'All OS',
        }],
      },
      userAttribute: {
        title: 'User properties',
        selected: 'selected',
        all: 'all',
        country: 'Country and region',
        allCountry: 'All country and region',
        mobile: 'Model',
        allMobile: 'All Model',
        os: 'OS',
        allOs: 'All OS',
        carrier: 'Carrier',
        allCarrier: 'All Carrier',
        channel: 'Channel',
        allChannel: 'All channel',
      },
    },
    // 创建用户分群的用户行为
    userBehavior: {
      behavior: 'Behavior',
      addPlaceholder: 'selected behavior',
      startTimes: {
        title: 'startTimes',
        unit: 's',
        totalStartTimes: 'totalStartTimes',
        dailyStartAvg: 'The average of the daily start times.',
        dailyStartMin: 'The min of the daily start times.',
        dailyStartMax: 'The max of the daily start times.',
      },
      userTimes: {
        title: 'userTimes',
        unit: 's',
        userTimes: 'userTimes',
      },
      launch_info: {
        title: 'Active',
        unit: 'day',
        launchDays: 'launchDays',
        userTrigger: 'At least 1 launch',
      },
      lostDays: {
        title: 'lost',
        unit: 'day',
        info: {
          a: 'Up to now',
          b: 'days,no launch',
        },
      },
      customevent: {
        title: 'Events',
      },
      page_view: {
        title: 'Pageview',
      },
    },
    // 创建用户分群的事件
    userGroupEvent: {
      userTrigger: 'At least 1 launch',
      allEvents: 'All standard events',
      between: 'between',
      difEvents: 'different events',
      addLabel: 'Selected Label',
      label: 'Event Label',
      noLabel: 'no Label',
      addBtn: 'Selected condition',
      choose: 'Selected',
      noData: 'Not found any data',
      loading: 'loading',
      chooseDate: 'Selected date',
      dateLt30: 'Span cannot exceed 30 days',
      tooEarly: 'Please select new date and later date for analysis',
      repeatBehavior: 'Filter conditions duplicate, please reselect',
      choiceTip: 'Please fill all condition',
    },
    userGroupPage: {
      userTrigger: 'The user has visited this page at least once: ',
      choose: 'Selected page',
    },
    // 小程序场景分析
    sceneAnalysis: {
      title: 'Scene Analysis',
      overview: {
        totalTimes: 'Total Visits',
        topScene: 'Scene of No.1 and its ratio to the total visits',
      },
      sceneDis: {
        tabs: 'Scene Distribution',
        legendNote: 'Top 10 Scenes',
        unit: 'Times',
      },
      firstSceneDis: {
        tabs: 'scene distribution of the first visits',
        legendNote: 'Top 10 scene of the first visits',
      },
      other: 'Others',
      disDetail: 'Scene distribution detail',
      totalVisit: 'Total page visits',
      tableColumn: {
        sceneID: 'Scene ID',
        sceneDes: 'Scene Description',
        pageAccessTimes: 'Page Visits',
        visitTimes: 'Visits',
        dayVisitTimes: 'Daily Visit',
        visitDev: 'Visit Users',
        devVisitTimes: 'Each User Visits',
        newDev: 'Number of New Users',
        operate: 'Operate',
      },
      sceneList: 'Scene Analysis',
      explain: {
        title: 'Definition',
        totalVisit: 'The total visits of Applets through all scene in the selected time period.',
        noOneSceneAndRatio: 'In the selected time period, the top scene whose visits account most among all scenes.',
        sceneID: 'The scene ID provided by Applets, which can be used to differentiate other scenes.',
        sceneDes: 'The description for each scene.',
        visitNum: 'Open the total number of Mini Program.',
        pageAccessNum: 'Total number of visits to the Mini Program page.',
        aveVisitNum: 'In the selected time period, the daily average visits to Applets through the selected scene.',
        visitDev: 'In the selected time period, the number of user launch Applets through the selected scene.',
        visitDevNum: 'In the selected time period, the average number of user launch Applets through the selected scene.',
        newDev: 'Users who access the applet for the first time by clicking Share Link.',
        operate: 'operate',
        ratio: 'In the selected time period, the ratio of visits through selected scene to total visits.',
      },
      error: 'Request Failed',
    },
    // 小程序场景详情
    sceneDetail: {
      overview: {
        pageAccessTimes: 'Page Visits',
        visitTimes: 'Visits',
        visitDev: 'Visit devices',
        newDev: 'The number of new devices',
        per: 'The ratio to the total visits',
      },
      trend: 'Trend：',
      detail: 'Detail：',
      pageAccessTimes: {
        tabs: 'Page Visits',
        totalTimes: 'Total Page Visits',
        dayAvgTimes: 'Daily Page Visit',
      },
      visitTimes: {
        tabs: 'Visit',
        totalTimes: 'Visit',
        dayAvgTimes: 'Daily Visit',
      },
      visitDev: {
        tabs: 'Visit Users',
        totalDev: 'Visit Users',
        dayAvgDev: 'Daily Visit User',
      },
      newDev: {
        tabs: 'New Users',
        totalNewDev: 'New Users',
        dayAvgNewDev: 'Daily New Users',
      },
      tableColumn: {
        date: 'Date',
        visitTimes: 'Visit',
        visitDev: 'Visit Users',
        visitPerDev: 'Each User Visits',
        newDev: 'New Users',
      },
    },
    // 扫码分析
    scanAnalysis: {
      title: 'Scan Analysis',
      overview: {
        scanTimes: 'Scan Times',
        scanDevs: 'Scan Users',
        newDevs: 'New Users',
        per: 'The ratio to the total visits',
      },
      scanTrend: 'Scan Trend',
      scanDetail: 'Scan Detail',
      createCode: 'Add new QRcode',
      date: 'date',
      scanTimes: {
        tabs: 'Scan Times',
        totalTimes: 'Total Scan Times',
        dayAvgTimes: 'Daily Scan Times',
      },
      scanDevs: {
        tabs: 'Scan Users',
        totalDev: 'Total Scan Users',
        dayAvgDev: 'Daily Scan Users',
      },
      newDevs: {
        tabs: 'New Users',
        totalNewDev: 'Total New Users',
        dayAvgNewDev: 'Daily New Users',
      },
      tableColumn: {
        codeName: 'QRcode Name',
        pagePath: 'Path of Current Page',
        codeType: 'Type',
        scanTimes: 'Scan Times',
        avgScanTimes: 'Daily Scan Times',
        scanDevs: 'Scan Users',
        scanTimesPerDev: 'Each User Scan Times',
        newDevs: 'New Users',
        operate: 'Operate',
      },
      qcodeType: {
        qcode: 'QCode',
        mini: 'MiniAppCode',
      },
      explain: {
        scanTimes: 'In the selected time period, the number of launching Applets through scanning qrcode.',
        scanDevs: 'In the selected time period, the number of users launching Applets through scanning qrcode.',
        newDevs: 'In the selected time period, the number of new users launching Applets through scanning qrcode.',
        ratio: 'In the selected time period, the number of launching Applets through scanning qrcode and its ratio to the total visits.',
      },
    },
    // 扫码详情
    scanDetail: {
      qcode: 'QRcode: ',
      overview: {
        scanTimes: 'Scan Times',
        scanDevs: 'Scan Users',
        newDevs: 'New Scan Users',
        per: 'The ratio to total visit',
      },
      trend: 'Trend',
      detail: 'Detail',
      tableColumn: {
        date: 'Date',
        scanTimes: 'Scan Times',
        scanDevs: 'Scan Users',
        scanTimesPerDev: 'Each User Scans',
        newDevs: 'New Scan Users',
      },
    },
    // 分享及传播
    shareDiss: {
      title: 'Forward Analysis',
      overview: {
        shareAmt: 'Forward Times',
        shareDeviceAmt: 'Forward Users',
        shareLinkClickAmt: 'Clicks on Forward Link ',
        newShareDeviceAmt: 'New Users',
        linkOfAll: 'Link click total open ratio',
        scenePro: 'Ratio to Total Visits',
        shareUser: 'Forward Users',
        shareAvg: 'Average Clicks Ratio',
        shareTip: 'Clicks Ratio',
      },
      trend: 'Forward Trend',
      date: 'Date',
      shareAmt: {
        tabs: 'Forward Times',
        allCount: 'Total Forward Times',
        dayCount: 'Average Forward Times',
      },
      shareDeviceAmt: {
        tabs: 'Forward Users',
        allCount: 'Total Forward Users (Unique User)',
        dayCount: 'Average Forward Users',
      },
      shareLinkClickAmt: {
        tabs: 'Clicks on Forward Link',
        allCount: 'Total Clicks on Link',
        dayCount: 'Average Clicks on Link ',
      },
      newShareDeviceAmt: {
        tabs: 'New Users',
        allCount: 'Total Users',
        dayCount: 'Average New Users',
      },
      shareTip: {
        tabs: 'Clicks Ratio',
        dayCount: 'Average Clicks Ratio',
      },
      page: 'Page',
      pageShare: 'Forward Page Details',
      pageName: 'Page Name',
      shareLinkClickDeviceAmt: 'Click on Forward Link Users',
      shareTipPro: 'Clicks Ratio',
      opreation: 'Operations',
      shareTop: 'Details',
      sharePage: 'Forward Page',
      userName: 'Username',
      headImg: 'Image',
      explain: [{
        title: 'Forward Times',
        content: 'In the selected time period, the number of forwarding Mini Programs.',
      }, {
        title: 'Forward Devices',
        content: 'In the selected time period, the number of devices forwarding Mini Programs.',
      }, {
        title: 'Clicks on Forward Link ',
        content: 'In the selected time period, the number of users clicking on forward links and launching Mini Programs.',
      },
      {
        title: 'Click on Forward Link Users',
        content: 'In the selected time period, the number of new users launching Mini Programs by clicking on forward links.',
      },
      {
        title: 'Clicks Ratio',
        content: 'In the selected time period, the average ratio of clicks on forward links to forward times.',
      },
        // {
        //   title: 'New Devices',
        //   content: 'In the selected time period, the number of new users launching Mini Programs by clicking on forward links.',
        // }
      ],
      newUserExplain: {
        title: 'New Users',
        content: 'Users who access the applet for the first time by clicking Share Link.',
      },
      linkOfAllExplain: {
        title: 'Link click total open ratio',
        content: 'The ratio of times the applet was accessed by sharing the scene during the selected date.',
      },
      explainAvgShareTipPro: 'In the selected time period, the average ratio of clicks on forward links to forward times.',
    },
    // 二维码管理
    qrcodeManage: {
      title: 'QR Code Management',
      createCode: 'Add New QR Code',
      batchCode: 'Add Batch QR Code',
      delete: 'Delete',
      delModal: 'Are you sure you want to delete the selected QR codes?',
      tablePoptip: {
        head: 'QR Code Classification and Explanation',
        fisrtLine: 'At present, Mini Programs officially provide 3 different types of QR codes, including Mini Program code (A), Mini Program code (B) and Mini Program QR code (C).',
        explainValue: [
          {
            title: 'Mini Program code (A)',
            explain: 'It is suitable for business scenarios requiring fewer QR codes and it is permanent. After scanning QR codes into the Mini Programs, users will directly enter the pages directed by the paths. ',
          }, {
            title: 'Mini Program code (B)',
            explain: 'It is suitable for business scenarios requiring a larger number of QR codes or only for temporary use. It is permanent and unlimited. After scanning QR codes into the Mini Programs, users will enter the home page, developers need to do the processing with the value of scene obtained from the page.',
          }, {
            title: 'Mini Program code (C)',
            explain: 'It is suitable for business scenarios requiring a few QR codes. After scanning QR codes into the Mini Programs, users will directly enter the page corresponding to page path.',
          },
        ],
        lastLine: 'The sum of Mini Program codes (A) and Mini Program QR codes can\'t exceed 100,000, please use with caution.',
      },
      table: {
        qcodeNm: 'QR Code Name',
        qcodeId: 'QR Code ID',
        appId: 'APP ID',
        qcodePath: 'Path',
        tdChannelId: 'Channel',
        qcodeParams: 'Parameters',
        qcodeType: 'Type',
        createTime: 'Created',
        operation: 'Operations',
        qcodeType1: 'QR Code',
        qcodeType2: 'Mini Program Code',
        null: 'Null',
      },
      // 创建二维码
      codeModal: {
        title: 'QR Code',
        downCode: 'Download',
        code500: 'Failed, please try again.',
        code40001: 'The App Secret is wrong or is not belong to current Mini Program, please verify the validity of the App Secret!',
        code40002: 'Please guarantee the value of grant_type is client_credential！',
        code40013: 'Please enter a valid App ID.',
        code40125: 'The App Secret is invalid, please confirm and try again.',
        code40164: 'The IP address that you use for calling the API is not in white list, please set up first.',
        code40165: 'The QR code has already existed!',
        code40166: ' Failed to get token from WeChat when generating QR code!',
        step1: {
          step: 'Step one',
          headerText: 'Fill out information',
          certain: 'Add New QR Code',
          cancel: 'Cancel',
        },
        step2: {
          step: 'Step two',
          headerText: 'Check information of QR Code',
          certain: 'Confirm',
          cancel: 'Close',
        },
        step3: {
          step: '',
          headerText: 'Edit QR Code',
          certain: 'Save',
          cancel: 'Close',
        },
        codeName: {
          title: 'QR Code Name',
          placeholder: 'Maximum 128 characters, support Chinese, letters and numbers',
        },
        appId: {
          title: 'Mini Program ID',
          placeholder: 'The Mini Program\'s App ID assigned by WeChat platform',
        },
        appSecret: {
          title: 'Mini Program Secret',
          placeholder: 'The Mini Program\'s Secret assigned by WeChat platform',
        },
        pageRoute: {
          title: 'Target path',
          placeholder: 'Mini Program\'s path, for example, pages/index/index. Including parameters, we support 128 bytes at most',
          popTip: {
            content: 'After users scanning the QR codes, it will open the page directed by the path',
          },
        },
        // 表单验证提示语
        warning: {
          appIdIsNull: 'This field is required',
          secretIsNull: 'This field is required',
          codeIsNull: 'This field is required',
          codeIsExisted: 'This QR Code Name already existed, please try another',
          codeError: 'Please enter Chinese, letters or numbers',
          channelIsNull: 'This field is required',
          channelError: 'Please enter letters or numbers, exclude space and other special characters',
          qcodePathIsNull: 'This field is required',
          qcodePathFirstLimt: 'The first character can\'t be "/"',
          qcodeError: 'Please enter letters or numbers, exclude space and other special characters',
          paramsIsNull: 'This field is required',
          // paramsIsChannel: 'Parameters can\'t be TDChannelID',
          paramsError: "'t' or 'TDChannelID' can not be used.",
          paramsRepeat: 'Parameters should be unique',
          valueIsNull: 'This field is required',
          valueError: 'Please enter letters or numbers',
          wordLimit: 'The total characters of target path, TDChannelID and customer parameters have exceed 128, please simplify',
        },
        type: {
          title: 'Type',
        },
        isChannel: {
          title: 'As a Channel?',
          placeholder: 'ChannelID, only support numbers and letters. Maximum 64 characters',
          yes: 'Yes',
          no: 'No',
          popTip: {
            content: 'If you use QR code as a channel, the value is directly assigned to this channel ID. Otherwise, it will be recorded as WeChat return scene value and do not make subdivisions. The default channel value is "TDChannelID". When you use other third-party tools to generate QR codes and set that as parameter, these QR codes are also recorded as an independent channels. ',
          },
        },
        params: {
          title1: 'Parameter',
          title2: 'Value',
          buttonText: 'Add Customer Parameters',
          placeholder1: 'Letters. For example, city',
          placeholder2: 'Letters or numbers. For example, zhang',
        },
      },
      // 批量创建二维码
      batchCodeModal: {
        title: 'Add Batch QR Code',
        submit: 'Submit',
        cancel: 'Cancel',
        createMethod: 'Created Type',
        editOnline: 'Online Batch Edit',
        templateUpload: 'Batch upload with template',
        downtemplate: 'Download',
        uploadList: 'Upload QR Code information list',
        down: 'Download',
        dragValue: 'Click or drag documents to here for uploading',
        pendingUpload: 'Documents to be uploaded',
        supportFile: 'Support extensions .xls .csv .xlsx',
      },
    },
    // 用户质量评估
    quality: {
      common: {
        loading: 'Loading...',
        nodata: 'Null',
        search: 'please enter keywords to search...',
        page: 'display per page',
        pre: 'Records',
        other: 'Other ',
        time: 'Date',
        pagesize: '/Page',
      },
      tabs: {
        new: 'Quality evaluation of new users',
      },
      date: {
        day7: 'Last 7 days',
        day30: 'Last 30 days',
      },
      titles: {
        title: 'Evaluation of user quality',
        overview: 'overview',
        silent: 'silent users',
        contrast: 'Comparison of  the quality of channel',
        pie: 'Overview',
        trend: 'Trend',
        keepuser: 'Retention',
      },
      user: {
        all: 'Total users',
        normal: 'Normal users',
        suspicious: 'Suspicious users',
        silent: 'Silent users',
        silentRate: 'Rate of silent users',
        normalRate: 'Rate of normal users',
        suspiciousRate: 'Rate of suspicious users',
        rate: ' rate',
        des: {
          all: 'All new users in selected duration',
          normal: 'Users not identified as suspicious users of all users ',
          suspicious: 'Users identified as suspicious users of all users ',
          silent: 'Users identified as suspicious users for less obvious human-machine interactivities of all users',
          silent_rate: 'Rate of silent users of all users',
        }
      },
      metric: {
        nextday: ' next-day retention rate',
        day7: ' 7-day retention rate',
        day30: ' 30-day retention rate',
      },
      table: {
        date: 'Date',
        all: 'All users',
        all_rate: 'Rate of all users',
        sus_rate: 'Rate of suspicious users',
        nor_rate: 'Rate of normal users',
        all_nextDay_rate: '1 day Retention Rate of all users',
        nor_nextDay_rate: '1 day Retention Rate of normal users',
        sus_nextDay_rate: '1 day Retention Rate of suspicious users',
        sil_nextDay_rate: '1 day Retention Rate of silent users',
        channel: 'Channel name',

      }
    },
  },
};
